const genericStrings = {
    stepCount: "Stap {current} van {total}",
    dragHint: "Sleep om te herschikken",
    shiftHours: "Diensturen",
    quantity: "Aantal",
    rate: "Tarief",
    printState: "Printstatus",
    showAccount: "Rekening bekijken",
    closed: "Gesloten",
    applyToWeek: "Toepassen op de hele week",
    addSlot: "Tijdvak toevoegen",
    copy: "Kopiëren",
    url: "URL",
    mode: "Modus",
    bulk: "Bulk",
    style: "Stijl",
    customName: "Aangepaste naam",
    customTableName: "Aangepaste tafelnaam",
    prefix: "Voorvoegsel",
    startTable: "Begintafel",
    endTable: "Eindtafel",
    single: "Enkel",
    unlimited: "Onbeperkt",
    custom: "Aangepast",
    dayRequired: "De dag is verplicht.",
    startHourRequired: "De begintijd is verplicht.",
    endHourRequired: "De eindtijd is verplicht.",
    selectAll: "Alles selecteren",
    deselectAll: "Alles deselecteren",
    displayOrder: "Volgorde",
    add: "Toevoegen",
    group: "Groep",
    image: "Afbeelding",
    visibility: "Zichtbaarheid",
    searchByName: "Zoeken op naam",
    searchByGroup: "Zoeken op groep",
    email: "E-mail",
    notAvailable: "N/A",
    noResult: "Geen resultaat.",
    searchResultsFor: "{count} resultaat voor “{query}” | {count} resultaten voor “{query}”",
    noResultHint: "Probeer een andere zoekterm.",

    voucher: "Bonnen",
    showPassword: "Wachtwoord tonen",
    hidePassword: "Wachtwoord verbergen",
    notDefined: "Niet ingesteld",
    allSaved: "Alles is opgeslagen",
    unsavedChanges: "1 wijziging | {count} wijzigingen",
    copied: "Gekopieerd",
    remove: "Verwijderen",
    apply: "Toepassen",
    invalidUrl: "Voer een geldige URL in die begint met https://",
    addImage: "Afbeelding uploaden",
    addFile: "Bestand uploaden",
    fileTypeError: "Dit bestandstype wordt niet geaccepteerd",
    openingHours: "Openingsuren",
    appRefund: "Terugbetaling",
    appHideCashboxButton: "Kassaknop verbergen",
    appNoPinUserLogin: "Gebruikerslogin zonder pincode",
    serviceMode: "Bestelling",
    duplicateProductWithGroup: "De producten van de groep meenemen in de duplicatie?",
    normal: "Normaal",
    existingClient: "Bestaande klant",
    newClient: "Nieuwe klant",
    next: "Volgende",
    previous: "Vorige",
    assignClient: "Klant toewijzen",
    searchClient: "Selecteer een klant",
    onSite: "Ter plaatse",
    cancelOrderedProduct: "Bestelde producten annuleren",
    showOnlyOwnAccounts: "Alleen eigen rekeningen tonen",
    cleanOption: "Subopties verwijderen",
    showProduct: "Naar product",
    showGroupsProduct: "Producten van de groep bekijken",
    username: "Gebruikersnaam",
    password: "Wachtwoord",
    org_id: "Organisatie-ID",
    sendInvoice: "Factuur versturen",
    customInvoiceNumber: "Factuurnummer",
    vatTicket: "Btw-ticket",
    vatTicketSend: "Versturen per e-mail",
    vatTicketDownloadHint: "Het btw-ticket wordt gedownload als pdf.",
    submit: "Versturen",
    edit: "Bewerken",
    hide: "Verbergen",
    preview: "Voorbeeld",
    moveUp: "Omhoog",
    moveDown: "Omlaag",
    duplicate: "Dupliceren",
    show: "Tonen",
    save: "Opslaan",
    cancel: "Annuleren",
    create: "Aanmaken",
    back: "Terug",
    search: "Zoeken",
    clearFilter: "Filter wissen",
    download: "Downloaden",
    send: "Verzonden",
    created: "Aangemaakt",
    canceled: "Geannuleerd",
    downloadX: "X downloaden",
    downloadZ: "Z downloaden",
    confirmLeave: "Je hebt niet-opgeslagen wijzigingen.<br/>Wil je deze pagina echt verlaten?",
    from: "Van",
    to: "Tot",
    digitalMenu: "Digitaal menu",
    viewApiDocs: "API-documentatie",
    deliveryArea: "Leveringszones",
    startDate: "Startdatum",
    endDate: "Einddatum",
    dateRange: "Periode",
    clear: "Wissen",
    total: "Totaal",
    paid: "Betaald",
    globalSearch: "Globale zoekopdracht",
    vat: "Btw",
    user: "Gebruiker",
    comment: "Opmerking",
    price: "Prijs",
    accountId: "Rekening-ID",
    name: "Naam",
    id: "Id",
    actions: "Acties",
    refresh: "Vernieuwen",
    account: "Rekening",
    accountInfo: "Accountinfo",
    status: "Status",
    openedAt: "Geopend op",
    closedAt: "Gesloten op",
    open: "Openen",
    close: "Sluiten",
    tableNumber: "Tafel",
    noName: "Geen naam",
    delete: "Verwijderen",
    takeaway: "Afhaal",
    deleteConfirm: "Weet je zeker dat je dit wil verwijderen?<br> Deze actie kan niet ongedaan gemaakt worden!",
    removeFromSelection: "Uit de selectie verwijderen",
    date: "Datum",
    filter: "Filter",
    matchContains: "Bevat",
    matchNotContains: "Bevat niet",
    matchStartsWith: "Begint met",
    matchEndsWith: "Eindigt op",
    matchEquals: "Gelijk aan",
    ipAddress: "Adres",
    yes: "Ja",
    color: "Kleur",
    no: "Nee",
    all: "Alle",
    changePayType: (ctx) => `Betaalwijze van ${ctx.named('of')} wijzigen van ${ctx.named('from')} naar ${ctx.named('to')}? `,
    tables: "Tafels",
    delivery: "Levering",
    shift: "Diensten",
    openAccounts: "Open rekeningen",
    openTicketsCurrentShift: "Rekeningen van de huidige dienst",
    lastShift: "Laatste dienst",
    dailySales: "Dagelijkse verkoop",
    rushHours: "Piekuren",
    dashboardIntervalChoice: 'Geselecteerde periode',
    dashboardIntervalCurrentShift: 'Huidige dienst',
    dashboardIntervalLastShift: 'Laatste dienst',
    dashboardIntervalYesterday: 'Gisteren',
    dashboardIntervalThisWeek: 'Deze week',
    dashboardIntervalLastWeek: 'Vorige week',
    dashboardIntervalThisMonth: 'Deze maand',
    dashboardIntervalLastMonth: 'Vorige maand',
    dashboardIntervalLast7Days: 'Laatste 7 dagen',
    dashboardIntervalLast30Days: 'Laatste 30 dagen',
    dashboardIntervalLast90Days: 'Laatste 90 dagen',
    dashboardIntervalCustom: 'Aangepast',
    dateTimePlaceholder: 'dd/mm/jjjj uu:mm',
    datePlaceholder: 'dd/mm/jjjj',
    clients: 'Klanten',
    superUserShort: 'SU',
    mail: 'E-mail',
    phone: 'Telefoon',
    address: 'Adres',
    street: 'Straat',
    city: 'Stad',
    shiftUser: "Werknemersdienst",
    noDataFound: "Geen gegevens gevonden",
    itemsSelected: "{count} geselecteerd",
    loadingData: "Gegevens worden geladen, even geduld.",
    fileSizeError: "Het bestand is te groot, kies een bestand kleiner dan {size} MB",
    fileAttached: "{name} — wordt geüpload bij het opslaan",
    pickup: "Afhaalpunt",
    promo: "Promotie",
    monday: "Maandag",
    tuesday: "Dinsdag",
    wednesday: "Woensdag",
    thursday: "Donderdag",
    friday: "Vrijdag",
    saturday: "Zaterdag",
    sunday: "Zondag",
    login: "Inloggen",
    product: "Producten",
    productGroup: "Productgroepen",
    table: "Tafels",
    select: "Selecteren",
    bulkEdit: "Bulkbewerking",
    bulkEditProducts: "{count} product bewerken | {count} producten bewerken",
    bulkEditGroups: "{count} groep bewerken | {count} groepen bewerken",
    printer: "Printers",
    client: "Klant",
    invoice: "Facturen",
    dashboard: "Dashboard",
    dashboardGroups: "Dashboard groepen",
    dashboardLimitedInterval: "Beperkte intervallen",
    accounts: "Rekeningen",
    order: "Bestellingen",
    stock: "Voorraad",
    error: "Fout",
    bankTransfer: "Overschrijving",
    offered: "Aangeboden",
    disableCash: "Cash uitschakelen",
    disableCard: "Kaart uitschakelen",
    kiosk: "Kiosk",
    payment: "Betaling",
    customerCredit: "Klantkrediet",
    paymentForced: "Geforceerde betaling",
    paymentTransaction: "Betaaltransacties",
    analytics: "Analyse",
    admin: "Beheer",
    paymentMethod: "Betaalwijze",
    transactionType: "Transactietype",
    amountPaid: "Totaal betaald",
    amountReturned: "Totaal teruggegeven",
    tip: "Fooi",
    rounding: "Afronding",
    none: "Geen",
    doNotChange: "Niet wijzigen",
    detachParent: "Losmaken van bovenliggende",
    cash: "Cash",
    card: "Kaart",
    free: "Gratis",
    mixed: "Gemengd",
    transfer: "Overschrijving",
    forceCloseShift: "Dienst geforceerd afsluiten",
    general: "Algemene app",
    appSearchAccounts: "Rekeningen zoeken",
    appCorrectPayment: "Betaling corrigeren",
    disableEatIn: "Ter plaatse uitschakelen",
    disableTakeaway: "Afhaal uitschakelen",
    emptyStateTitle: "Geen gegevens",
    emptyStateText: "Start een dienst om je dashboard te bekijken.",
    emptyStateBtn: "Dienst starten",
    newVersionReload: "Er is een nieuwe versie van de admin beschikbaar. Herlaad de pagina.",
    serviceDetails: "Servicedetails",
    hours: "Uren",
    cashRegister: "Kassa",
    start: "Start",
    end: "Einde",
    invoicing: "Facturatie",
    invoice_send: "Versturen",
    invoice_get: "Bekijken",
    invoice_all: "Volledige toegang",
    invoice_paid: "Markeren/bekijken",
    orgType: "Organisatietype",
    reorganize: "Herschikken",
    done: "Opslaan",
    tabletMode: "Tabletweergave",
    exitTabletMode: "Tabletweergave verlaten",
    subOption: "Subopties",
    barcode: "Barcode",
    advanced: "Geavanceerd",
    optionProduct: "Productopties",
    confirmAction: "Weet je zeker dat je deze actie wil uitvoeren?",
    orderAtTable: "BESTELLEN AAN TAFEL",
    generateCodeQr: "QR-code genereren",
    dynamicPrice: "Dynamische prijs",
    summaryRev: "Overzicht wijzigingen",
    reset: "Resetten",
};

const navBarStrings = {
    products: "Producten",
    catalog: "Catalogus",
    groups: "Groepen",
    productOptions: "Optielijsten",
    home: "Home",
    users: "Gebruikers",
    tables: "Tafels",
    my_account: "Mijn account",
    settings: "Instellingen",
    dashboard: "Dashboard",
    analytics: "Analyse",
    account: "Account",
    image: "Afbeeldingen",
    pickup: "Afhaal",
    acitivity: "Activiteit",
    order_history: "Bestellingen",
    account_history: "Rekeningen",
    shifts: "Diensten",
    shift: "Dienst Z",
    payments: "Betalingen",
    log: "Logboek",
    logout: "Afmelden",
    printers: "Printers",
    stock: "Voorraad",
    clients: "Klanten",
    invoice: "Facturen",
    kitchen: "Bericht",
    promo: "Promoties",
    extIntegration: "Integraties",
    createOrg: "Organisatie aanmaken",
    superUser: "Super User",
    superUsers: "Super Users",
    dashboardSU: "Dashboard SU",
    menu: "Menu",
    importCSV: "Menu importeren",
    icons: "Iconen",
    vouchers: "Bonnen",
    searchOrg: "Zoek een organisatie",
    noOrgFound: "Geen organisatie gevonden",
    deliveryAreas: "Levering"
}

const integrationStrings = {
    addInt: "Integratie toevoegen",
    ipAddress: "Adres",
    user: "Gebruiker",
    protocol: "Protocol",
    localPrint: "Lokaal afdrukken",
    serialNumber: 'Serienummer',
    webtoolUrl: 'Webtool-URL',
    authKey: 'Authenticatiesleutel',
    noIntegration: "Geen integratie",
    noIntegrationHint: "Voeg een integratie toe om te beginnen.",
    editInt: "Integratie bewerken"
}

const toastStrings = {
    vatTicketSent: "Btw-ticket verzonden",
    groupNameTooShort: "De naam moet minstens 3 tekens bevatten",
    successSave: "Opslaan gelukt",
    errorSave: "Fout bij het opslaan",
    successEdit: "Wijziging gelukt",
    errorEdit: "Fout bij het wijzigen",
    createSuccess: "Aanmaken gelukt",
    createError: "Fout bij het aanmaken",
    deleteSuccess: "Verwijderen gelukt",
    deleteError: "Fout bij het verwijderen",
    duplicateSuccess: "Duplicatie gelukt",
    duplicateError: "Fout bij het dupliceren",
    copySuccess: "Link gekopieerd",
    deleteGroupNotAllowed: "Een niet-lege groep kan niet verwijderd worden.",
    errorNotSelected: "Selecteer minstens één item",
    cannotDeleteInvoicedAccount: "Een reeds gefactureerde rekening kan niet verwijderd worden.",
    cannotEdit: "Overgeërfd item: sommige velden zijn niet bewerkbaar.",
    downloadError: "Het downloaden is mislukt, probeer het opnieuw."
};

const loginPageStrings = {
    welcome_back: "Welkom terug",
    login_page_subtitle: "Je ideale partner voor je zaak, altijd beschikbaar wanneer je hem nodig hebt",
    login_page_form_title: "Opnieuw inloggen",
    login_page_form_subtitle: "Vul je inloggegevens in",
    login_button: "Inloggen"
}

const dashboardStrings = {
    morePeriods: "Meer",
    organisations: "Organisaties",
    devices: "Apparaten",
    openShifts: "Open diensten",
    orgName: "Naam van de organisatie",
    searchOrganisation: "Zoek een organisatie...",
    searchShift: "Zoek een dienst, een organisatie...",
    noOrganisation: "Geen organisatie",
    noOpenShift: "Geen open dienst",
    switchToOrg: "Naar deze organisatie schakelen",
    openShiftDetail: "Dienst bekijken",
    lastDays: "Laatste {days} dagen",
    yoursInfos: "Jouw zaak",
    empty: "Geen enkele tafel is bezet",
    shiftTitle: "Tafel openen",
    openTableText: "Tafel openen",
    takeawayText: "Afhaal openen",
    noshiftOpen: "Geen dienst geopend",
    takeawayTitle: "Afhaal",
    currentShift: "Huidige dienst",
    latestShift: "Laatste dienst",
    lastShift: "Laatste dienst",
    accountsTotal: "Totaal rekeningen",
    accountsTooltip: 'Totaal aantal open EN gesloten rekeningen met minstens 1 betaald item.',
    remainingUnpaid: "Nog te betalen",
    remainingUnpaidTooltip: "Het totale bedrag van bestelde items die nog volledig of gedeeltelijk betaald moeten worden",
    salesPaid: "Betaalde verkoop",
    salesPaidTooltip: "Het totale bedrag van betaalde items op de rekeningen van de geselecteerde dienst(en)",
    averageBasket: "Gemiddelde besteding",
    orgId: "Org-ID",
    unnamedOrg: "Naamloze organisatie",
};

const productGroupsDashboardStrings = {
    title: "Verkoop per productgroep",
    totalRevenue: "Omzet",
    totalRevenueTooltip: "Totale omzet (incl. btw) van alle weergegeven groepen",
    quantitySold: "Verkochte hoeveelheid",
    accountCount: "Rekeningen",
    accountCountTooltip: "Aantal verschillende rekeningen (tickets)",
    averageBasket: "Gemiddelde besteding",
    subGroups: "Subgroepen",
    topProducts: "Topproducten",
    rushHours: "Piekuren",
    revenueInclVat: "Totale verkoop",
    vatByRate: "Btw per tarief",
    vatRate: "Tarief",
    vatExcl: "Excl. btw",
    vatAmount: "Btw",
    vatIncl: "Incl. btw",
    salesByChannel: "Verkoop per kanaal",
    paymentCash: "Contant",
    paymentCard: "Kaart",
    paymentTransfer: "Overschrijving",
    discountTotal: "Kortingen",
    averagePrice: "Gemiddelde prijs",
    details: "Details",
    empty: "Geen gegevens om weer te geven voor deze periode",
    forbidden: "Je hebt geen toegang tot dit dashboard",
};

const userPageStrings = {
    createPartialError: "De gebruiker is aangemaakt, maar sommige instellingen konden niet worden opgeslagen: {error}. Bewerk de gebruiker om ze aan te vullen.",
    kdsCallMode: "KDS-oproepschermmodus",
    kdsCallModeTooltip: "Wanneer dit is ingeschakeld, verschijnt elke bestelling in één status op het keukenscherm. Een bestelling gaat naar 'in bereiding' zodra één item wordt klaargemaakt, en naar 'klaar' pas wanneer alle items klaar zijn.",
    userSubscribedProductGroupIds: "Productgroepen",
    userSubscribedProductGroupIdsTooltip: "De gebruiker ziet na het inloggen enkel de geselecteerde groepen.",
    userSubscribedZoneId: "Tafelzones",
    userSubscribedZoneIdTooltip: "De gebruiker ziet na het inloggen enkel de geselecteerde zones.",
    username: "Gebruikersnaam",
    password: "Wachtwoord",
    vwMultiMerchantId: "VW Multi Merchant ID",
    vwMultiMerchantIdTooltip: "Identificeert de merchantrekening van de gebruiker in de multi-merchantconfiguratie van Viva Wallet.",
    type: "Gebruikerstype",
    pincode: "Pincode",
    vwTerminalIp: "VW terminal-IP",
    vwTerminalId: "VW terminal-ID (cloud)",
    userPrinter: "Printer van de gebruiker",
    selectAbilities: "Rechten selecteren",
    appMode: "App-modus",
    pincodeTooltip: "De pincode die nodig is om de app te ontgrendelen wanneer de pinvergrendeling actief is. Hiermee kunnen ook acties van gebruikers gevolgd worden op basis van de ingevoerde pincode op de hoofdkassa.",
    userPrinterTooltip: "De printer die voor deze gebruiker gebruikt wordt. Deze overschrijft de hoofdprinter en laat toe btw-/overzichtstickets op deze printer af te drukken",
    fullAccess: "Volledige toegang",
    userIntegrations: "Integraties",
    userIntegrationsTooltip: "De integraties (betaalautomaat, betaalterminal…) gekoppeld aan deze gebruiker. Een integratie van een andere gebruiker aanvinken verplaatst ze naar deze, een integratie uitvinken verwijdert ze bij het opslaan.",
    integrationsDeleteWarning: "Let op, deze integraties worden verwijderd bij het opslaan: {list}",
    kdsSubscribedProductGroupIds: "KDS-productgroepen",
    kdsSubscribedProductGroupIdsTooltip: "Bepaal welke productgroepen naar deze KDS-gebruiker gestuurd worden. Zonder toegewezen groepen ontvangt de gebruiker alle bestellingen.",
    addUser: "Gebruiker toevoegen",
    niss: "INSZ",
    blackboxTester: "Opleiding",
    cannotDeleteAdmin: "Deze gebruiker kan niet verwijderd worden",
    duplicate: "Dupliceren",
    cannotDuplicateUser: "Deze gebruiker kan niet gedupliceerd worden",
    duplicateFrom: "Kopie van {username}",
    duplicateMissingFields: "Vul de gebruikersnaam, het wachtwoord en de pincode in",
    passwordGenerationRequired: "Genereer een wachtwoord",
    passwordGeneratePlaceholder: "Geen wachtwoord",
    apiDocsPasswordRules: "Met toegang tot de API-documentatie moet het wachtwoord minstens {length} tekens bevatten, waaronder een hoofdletter, een kleine letter, een cijfer en een speciaal teken",
    apiDocsPasswordRegenerate: "Toegang tot de API-documentatie is net toegevoegd: genereer het wachtwoord opnieuw om er een van {length} tekens te krijgen",
    adminPasswordRules: "Het admin-wachtwoord moet minstens {length} tekens bevatten, waaronder een hoofdletter, een kleine letter en een speciaal teken",
    linkDevice: "Apparaat koppelen",
    pairingCode: "Koppelcode",
    pairingCodePlaceholder: "000000",
    pairingCodeTooltip: "De 6-cijferige code die op het te koppelen apparaat wordt getoond. Ze blijft 10 minuten geldig zolang het apparaat op het koppelscherm blijft.",
    linkDeviceWarning: "Het apparaat logt in met dit account zonder wachtwoord. Een apparaat dat al aan dit account gekoppeld is, moet opnieuw inloggen met zijn wachtwoord.",
    linkDeviceWaiting: "Wachten tot het apparaat inlogt, dit kan tot 60 seconden duren…",
    linkDeviceSuccess: "Apparaat succesvol gekoppeld",
    linkDeviceError: "Het apparaat kon niet gekoppeld worden",
    pairingCodeOptional: "Optioneel",
    pairingCodeEditTooltip: "Voer de 6-cijferige code in die op het apparaat wordt getoond, zodat het bij het opslaan meteen inlogt met dit account. Een apparaat dat al aan dit account gekoppeld is, moet opnieuw inloggen met zijn wachtwoord.",
    pairingCodeInvalid: "De koppelcode moet 6 cijfers bevatten",
    createLinkDeviceError: "De gebruiker is aangemaakt, maar het apparaat kon niet gekoppeld worden: {error}. Bewerk de gebruiker om de code opnieuw in te voeren.",
    scanPairingCode: "QR-code scannen",
    scanPairingCodeInvalid: "Deze QR-code bevat geen koppelcode",
    cameraUnavailable: "De camera is niet toegankelijk. Sta hem toe in de browserinstellingen.",
    cameraRequiresHttps: "De camera is alleen beschikbaar op een HTTPS-pagina.",
    linkDeviceUser: "Gebruiker",
    linkDeviceUserPlaceholder: "Kies een gebruiker"
}

const superUserPageStrings = {
    validation: {
        username: "De gebruikersnaam is verplicht",
        email: "Het e-mailadres is verplicht"
    },
    createTitle: "Super User aanmaken",
    editTitle: "Super User bewerken",
    addSuperUser: "Super user toevoegen",
    username: "Gebruikersnaam",
    usernameHint: "Moet beginnen met su_",
    email: "E-mail",
    phoneNumber: "Telefoonnummer",
    partnerSource: "Partnerbron",
    abilities: "Rechten",
    abilityCreateOrg: "Organisatie aanmaken",
    abilityCreateUser: "Super User aanmaken",
    abilityViewApiDocs: "Toegang tot API-documentatie",
    regenerate: "Opnieuw genereren",
    regeneratePassword: "Wachtwoord opnieuw genereren",
    regeneratePasswordConfirm: "Wachtwoord van {username} opnieuw genereren?<br>Het wordt naar {email} gestuurd.",
    deleteConfirm: "Weet je zeker dat je {username} wil verwijderen?<br> Deze actie kan niet ongedaan gemaakt worden."
}

const productGroupPageStrings = {
    deleteBlocked: "Verwijderen niet mogelijk: deze groepen bevatten nog producten of subgroepen die niet geselecteerd zijn: {groups}",
    addSubGroup: "Subgroep toevoegen",
    productGroups: "Productgroepen",
    addGroup: "Groep toevoegen",
    expandAll: "Alles openklappen",
    collapseAll: "Alles dichtklappen",
    searchGroup: "Zoek een groep",
    noParent: "Geen (zelfstandige groep)",
    manageSubGroups: "Subgroepen beheren",
    selectAll: "Alles selecteren",
    deselectAll: "Alles deselecteren",
    vatIn: "Btw ter plaatse",
    vatOut: "Btw afhaal",
    printerIp: "IP-adres printer",
    name: "Naam",
    userHidden: "Verbergen in de app?",
    webHidden: "Verbergen op de website?",
    isHidden: "Verborgen in de app",
    isNotHidden: "Zichtbaar in de app",
    KitchenPrintEnabled: "Afdrukken",
    groupOrder: "Groepsvolgorde",
    loadingResultTable: "Gegevens worden geladen. Even geduld.",
    color: "Kleuren",
    assignToAllProduct: "Toewijzen aan alle producten",
    assignToAllProductTooltip: "Schakel deze optie in om deze groep aan al je producten toe te wijzen",
    assignVatToAllProducts: "Btw toewijzen aan alle producten",
    assignVatToAllProductTooltip: "Schakel deze optie in om de btw van deze groep aan alle producten toe te wijzen",
    vatTooltip: "Een btw-tarief dat voorgesteld wordt wanneer deze groep aan een product wordt toegewezen. Dit wijzigen verandert de btw van bestaande producten in deze groep niet",
    orderTooltip: "Volgorde van de groep in de lijst; groepen worden oplopend gesorteerd",
    kitchenPrintEnabledTooltip: "Het afdrukken van bestellingen op de toegewezen printer voor producten van deze groep in-/uitschakelen",
    userHiddenTooltip: "Verberg deze groep in de gebruikersinterface zodat producten uit deze groep niet rechtstreeks besteld kunnen worden, maar wel bruikbaar blijven als betaalde/gratis productoptie",
    hideNameOnKiosk: "Naam verbergen op kiosk",
    hideNameOnKioskTooltip: "Verbergt de naam van deze groep op de kiosk, zodat enkel de afbeelding of het icoon getoond wordt. De groep blijft zichtbaar en selecteerbaar.",
    maxChoicePaid: "Max. betalend in subgroep",
    maxChoiceFree: "Max. gratis in subgroep",
    optionOrderTooltip: "Volgorde van deze groep wanneer ze als optie bij een product gebruikt wordt",
    maxChoicePaidToolTip: "Wanneer je deze groep aan een product koppelt, kan je een maximum aantal betalende producten instellen dat gekozen mag worden.",
    maxChoiceFreeToolTip: "Wanneer je deze groep aan een product koppelt, kan je een maximum aantal gratis producten instellen dat gekozen mag worden.",
    activeHours: "Happy hours",
    activeHoursToolTip: "Schakel in om een tijdslot te bepalen waarin deze groep zichtbaar en verkoopbaar is in de kassa.",
    printOnAllPrinters: "Op alle printers afdrukken",
    printOnAllPrintersTooltip: "Indien ingeschakeld worden producten van deze groep op alle aan de groep toegewezen printers afgedrukt, in plaats van de gebruiker bij het bestellen een printer te laten kiezen.",
    forcedChoiceAmountFree: "Verplichte gratis keuzes",
    forcedChoiceAmountFreeTooltip: "Exact aantal gratis opties dat gekozen moet worden.",
    forcedChoiceAmountPaid: "Verplichte betalende keuzes",
    forcedChoiceAmountPaidTooltip: "Exact aantal betalende opties dat gekozen moet worden.",
    allowMultipleChoiceOnSameItems: "Dezelfde subopties meerdere keren toestaan",
    allowMultipleChoiceOnSameItemsTooltip: "Laat toe dezelfde suboptie meerdere keren te kiezen voor één product.",
    enablePopup18: "18+-pop-up inschakelen",
    enablePopup: "Aangepaste pop-up inschakelen",
    enablePopupToolTip: "Toont een aangepaste pop-up wanneer een product uit deze groep wordt gekozen",
    picto: "Picto",
    enablePopupTooltip: "Schakel het tonen van een pop-up voor deze groep op je website in of uit.",
    enablePopup18Tooltip: "Schakel het tonen van een leeftijdscontrole-pop-up voor deze groep op je website in of uit.",
    descriptionPopup: "Tekst van de pop-up"
}

const catalogPageStrings = {
    exportProducts: "Producten exporteren",
    exportTemplate: "Sjabloon exporteren",
    exportLegacy: "Export (Legacy)",
    openGroup: "Groep openen",
    showProducts: "Producten tonen",
    hideProducts: "Producten verbergen",
    expandGroup: "Groep uitklappen",
    collapseGroup: "Groep inklappen",
    productsCount: "geen product | 1 product | {count} producten",
    subgroupsCount: "geen subgroep | 1 subgroep | {count} subgroepen",
    itemsCount: "geen element | {count} element | {count} elementen",
    moveSelection: "De selectie verplaatsen ({count})",
    inheritedSelectionDisabled: "Selectie is uitgeschakeld voor items die van de bovenliggende organisatie zijn overgenomen",
    editGroups: "De groep bewerken | De {count} groepen bewerken",
    deleteGroups: "De groep verwijderen | De {count} groepen verwijderen",
    editProducts: "Het product bewerken | De {count} producten bewerken",
    deleteProducts: "Het product verwijderen | De {count} producten verwijderen",
    downloadSelection: "Downloaden ({count})",
}

const productOptionsPageStrings = {
    duplicateList: "De lijst dupliceren",
    duplicateWithItems: "De opties van de lijst meenemen in de duplicatie?",
    copyName: "{name} (kopie)",
    name: "Optielijsten",
    addList: "Een lijst aanmaken",
    searchPlaceholder: "Een lijst zoeken",
    empty: "Geen optielijst",
    nameFR: "Naam (FR)",
    nameNL: "Naam (NL)",
    nameBase: "Naam (basis)",
    minChoiceTotal: "Minimum aantal keuzes",
    maxChoiceTotal: "Maximum aantal keuzes",
    forceChoiceTotal: "Verplichte keuzes",
    minChoiceTotalTooltip: "Minimum aantal opties dat in deze lijst gekozen moet worden",
    maxChoiceTotalTooltip: "Maximum aantal opties dat in deze lijst gekozen mag worden",
    forceChoiceTotalTooltip: "Exact aantal opties dat in deze lijst gekozen moet worden",
    forceOverridesMinMax: "Er is een aantal keuzes verplicht: het minimum en het maximum gelden niet meer.",
    newList: "Nieuwe lijst",
    createList: "De lijst aanmaken",
    selectListHint: "Selecteer een lijst of maak een nieuwe aan",
    sectionName: "Naam",
    sectionRules: "Keuzeregels",
    sectionProducts: "Producten",
    sectionPrice: "Prijs",
    sectionSettings: "Instellingen",
    free: "Gratis",
    freeTooltip: "Deze optie wordt als gratis beschouwd bij het opnemen van een bestelling",
    multiple: "Meervoudig",
    price: "Prijs",
    priceInOut: "Prijs In/Out",
    priceOnSite: "Prijs ter plaatse",
    priceTakeaway: "Prijs afhaal",
    priceTooltip: "Prijs van de optie; laat leeg om de normale productprijs te behouden",
    priceTakeawayTooltip: "Afhaalprijs van de optie; laat leeg om de normale productprijs te behouden",
    pricePerPlatform: "Prijs per platform (In/Out)",
    pricePerPlatformTooltip: "Prijs ter plaatse en afhaal per platform; laat leeg om de normale productprijs te behouden",
    typeLabel: "Optietype",
    typePrefix: "Voorvoegsel",
    actionsTooltip: "De optie herschikken, bewerken of verwijderen",
    typeTooltip: "Bijzonder optietype, bv. \"Zonder\" om een ingrediënt te verwijderen",
    unsavedChangesConfirm: "Sommige wijzigingen zijn niet opgeslagen. Wilt u ze verwerpen?",
    productsCount: "geen product | {count} product | {count} producten",
    addExistingProduct: "Een bestaand product toevoegen",
    createProduct: "Nieuw product",
    createGroup: "Nieuwe groep",
    otherGroup: "Andere",
    noItems: "Geen optie in deze lijst",
    inherited: "Overgeërfd",
    inheritedTooltip: "Lijst overgeërfd van de bovenliggende organisatie: alleen lezen",
    typeWith: "Met",
    typeWithout: "Zonder",
    allowMultipleChoice: "Meervoudige keuze toegestaan",
    allowMultipleChoiceTooltip: "De optie kan meerdere keren in dezelfde bestelling gekozen worden",
    maxChoice: "Maximum aantal keren",
    maxChoiceTooltip: "Maximum aantal keren dat deze optie in een bestelling gekozen kan worden",
    includeOptionLists: "Optielijsten van het product opnemen",
    includeOptionListsTooltip: "De eigen optielijsten van dit product worden ook aangeboden wanneer deze optie gekozen wordt",
    validation: {
        name: "Minstens één naam is vereist",
        minMax: "Het minimum moet kleiner of gelijk zijn aan het maximum",
        negative: "Waarden moeten positief zijn"
    }
};

const productPageStrings = {
    zeroVatConfirm: "Dit product heeft 0% btw. Weet u zeker dat u het met 0% btw wilt opslaan?",
    zeroVatConfirmMany: "{count} product(en) hebben 0% btw. Weet u zeker dat u ze met 0% btw wilt opslaan?",
    favorite: "Favoriet",
    ingredient: "Ingrediënt",
    optionLists: "Optielijsten",
    addOptionLists: "Opties toewijzen",
    priceBasis: "Prijs baseren op",
    priceBasisTooltip: "Kopieert de gekozen prijs van elk product naar de andere prijs. Handig als alleen de prijs ter plaatse is ingevuld.",
    priceBasisIn: "Prijs ter plaatse",
    priceBasisOut: "Afhaalprijs",
    visibilityApp: "Zichtbaar op kassa",
    name: "Productnaam",
    products: "Producten",
    addProduct: "Product toevoegen",
    noProductInGroup: "Geen product in deze groep",
    priceVatInclIn: "Prijs ter plaatse",
    priceVatInclOut: "Prijs afhaal",
    vatIn: "Btw ter plaatse",
    vatOut: "Btw afhaal",
    codeBarre: "Barcode",
    description: "Beschrijving",
    stock: "Voorraad",
    productGroup: "Productgroep",
    productGroupParent: "Bovenliggende groep",
    productGroupOptions: "Gratis optiegroepen",
    productGroupOptionsPaid: "Betalende optiegroepen",
    productFilterByCategory: "Filteren op categorie",
    timedproduct: "Product per tijd?",
    allowDecimal: "Decimale eenheden toestaan?",
    dynamicPrice: "Dynamische prijs?",
    multiChoice: "Meerdere keuzes toegestaan?",
    orderIndex: "Volgorde",
    optionOrderIndex: "Volgorde als optie",
    weightPrice: "Prijs per gewicht?",
    visibility: "Zichtbaarheid app",
    visibilityWeb: "Zichtbaarheid web",
    visibilityKiosk: "Zichtbaarheid kiosk",
    userHiddenTooltip: "Verberg dit product in de gebruikersinterface zodat het niet rechtstreeks besteld kan worden, maar wel bruikbaar blijft als betaalde/gratis productoptie",
    imageUrl: "URL hoofdafbeelding in https",
    extraImageUrls: "URL's extra afbeeldingen in https",
    extraImageUrlsTooltip: "Vul de URL's van je extra afbeeldingen in; ze worden gebruikt om de productfoto's op je website te tonen. Scheid elke URL met een komma en eindig ook met een komma.",
    allergens: "Allergenen",
    color: "Kleur",
    orderTooltip: "Volgorde van het product in de lijst; producten van dezelfde groep worden oplopend gesorteerd",
    timedProductTooltip: "Wanneer dit is ingeschakeld, start dit product een timer bij het bestellen en wordt bij het afsluiten de productprijs als prijs per minuut gebruikt om het totaal te berekenen",
    allowDecimalTooltip: "Laat de gebruiker een decimale waarde invoeren voor de hoeveelheid, via lang indrukken voor het bestellen of via product > eenheden",
    dynamicPriceTooltip: "Hiermee wordt de bovenstaande prijs genegeerd en moet de gebruiker een prijs invoeren wanneer dit product gekozen wordt",
    weightPriceTooltip: "Hiermee moet de gebruiker een gewicht in kg invoeren wanneer dit product gekozen wordt. Het gewicht wordt automatisch gedetecteerd als er een weegschaal aangesloten is",
    promo_percent: "Vaste promotie in %",
    webHiddenTooltip: "Verberg deze groep in de webinterface zodat producten uit deze groep niet rechtstreeks besteld kunnen worden, maar wel bruikbaar blijven als betaalde/gratis productoptie",
    tags: "Tags",
    parentProduct: "Bovenliggend product online bestellen",
    parentProductTooltip: "Dit product is een onderdeel van het geselecteerde product en verschijnt als optie op het platform voor online bestellen",
    tagsTooltip: "Vul je tags in; ze worden gebruikt om je producten op je website te filteren. Scheid elke tag met een komma.",
    enterBarcode: "Barcode invoeren",
    externalReference: "Externe referentie",
    externalReferenceTooltip: "Referentie om dit product/deze groep te koppelen aan een item van een ander platform of extern systeem.",
    kioskHidden: "Verbergen op kiosk?",
    kioskHiddenTooltip: "Schakel deze optie in om dit product/deze groep enkel op je kiosk te verbergen.",
    purchasePriceVatExcl: "Aankoopprijs",
    optionsDescription: "Aangepaste beschrijving van de opties",
    optionsDescriptionTooltip: "Stel een aangepaste optiebeschrijving in die onder de productnaam getoond wordt in plaats van de standaardopties (namen van de toegewezen suboptiegroepen)",
}

const stockPageStrings = {
    emptyTable: "Geen geschiedenis gevonden.",
    name: "Productnaam",
    stock: "Voorraad",
    productGroup: "Productgroep",
    productGroupOptions: "Gratis optiegroepen",
    productGroupOptionsPaid: "Betalende optiegroepen",
    productFilterByCategory: "Filteren op categorie",
    timedproduct: "Product per tijd?",
    allowDecimal: "Decimalen toestaan?",
    newStock: "Nieuwe voorraad",
    stockVariation: "Voorraadwijziging",
    editedBy: "Gewijzigd door"
}

const kitchenPageStrings = {
    name: "Keukenbericht",
    addMessage: "Bericht aanmaken",
    message: "Bericht",
    textEnter: "Bericht: ",
    erText: 'Bericht verplicht',
    noFundResultTable: "Geen bericht gevonden.",
}

const imagePageStrings = {
    name: "Media",
    addImage: "Media toevoegen",
    textEnter: "Voer een url in: ",
    textUpload: "Sleep je media hierheen of klik om toe te voegen",
    fileTooLarge: "Het bestand overschrijdt de limiet van 2 MB",
    limit: "Het bestand overschrijdt de limiet van 2 MB",
    allTypes: "Alle types",
    imagesOnly: "Afbeeldingen",
    videosOnly: "Video's",
    addSuccess: "{count} media toegevoegd",
    addError: "{count} media konden niet worden toegevoegd",
    uploadLimits: "Afbeeldingen tot {image} MB, video's tot {video} MB",
    noMedia: "Geen media",
    noMediaHint: "Voeg een afbeelding of video toe om te beginnen.",
    type: "Type",
    video: "Video"
}

const iconsPageStrings = {
    name: "Iconen",
    addIcon: "Icoon toevoegen",
    internalName: "Interne naam",
    nameFR: "Naam (FR)",
    nameNL: "Naam (NL)",
    nameEN: "Naam (EN)",
    searchPlaceholder: "Zoek een icoon",
    empty: "Geen iconen gevonden",
    preview: "Voorbeeld",
    category: "Categorie",
    url: "URL",
    allCategories: "Alle categorieën",
    group: "Groep",
    ingredient: "Ingrediënt",
    textUpload: "Sleep je iconen hierheen of klik om toe te voegen",
    addSuccess: "{count} icoon(en) toegevoegd",
    addError: "{count} icoon(en) konden niet toegevoegd worden",
    categoryValues: {
        GROUP: "Groep",
        ALLERGEN: "Allergeen"
    },
    validation: {
        name: "Naam is verplicht",
        url: "URL is verplicht",
        file: "Afbeelding is verplicht",
        category: "Categorie is verplicht",
        duplicateName: "Deze naam wordt meer dan één keer gebruikt"
    }
}


const tableStrings = {
    name: "Tafels",
    addTable: "Tafel toevoegen",
    nameZones: "Zones",
    selectZone: "Zones selecteren",
    addZones: "Zone toevoegen",
    addTableZone: "Een tafelzone toevoegen",
    nameTypes: "Types",
    selectType: "Types selecteren",
    addTypes: "Tafeltype toevoegen",
    tableNumber: "Tafelnummer",
    zoneNumber: "Zonenummer",
    zoneName: "Zonenaam",
    typeName: "Typenaam",
    qrAllTables: "Downloaden als ZIP ({count} tafel) | Downloaden als ZIP ({count} tafels)",
    qrNoTables: "Geen tafel om te genereren",
    createZone: "Zone aanmaken",
    editZone: "Zone bewerken",
    noZone: "Geen zone",
    tableCount: "{count} tafel | {count} tafels",
    emptyTables: "Geen tafels",
    invalidColor: "Ongeldige kleur, gebruik het formaat #RRGGBB"
}


const clientStrings = {
    emptyTable: "Geen klanten gevonden.",
    addClient: "Klant toevoegen",
    name : "Naam",
    phone: "Telefoonnummer",
    street: "Straat",
    city: "Stad",
    extra: "Extra info",
    zipCode: "Postcode",
    number: "Nummer",
    box: "Bus",
    business: "Bedrijf",
    vat: "Btw-nummer",
    email: "E-mail",
    erZipCode: "Postcode is verplicht",
    erNumber: "Nummer is verplicht",
    erName: "Naam is verplicht",
    erPhone: "Telefoonnummer is verplicht",
    erStreet: "Straat is verplicht",
    erCity: "Stad is verplicht",
    erPhone2: "Telefoonnummer is ongeldig",
    erBox: "Bus is verplicht",
    erMail: "E-mail is verplicht",
    erMail2: "E-mail is ongeldig",
    erBusiness: "Bedrijf is verplicht",
    erVat2: "Btw-nummer is ongeldig",
    editClient: "Klant bewerken",
}

const paymentsStrings = {
    header: "Betaaltransacties",
    orderId: "Bestel-ID",
    paymentType: "Type",
    amount: "Bedrag",
    returned: "Teruggegeven",
    totalCash: "Totaal cash",
    totalCard: "Totaal kaart",
    totalOffered: "Totaal aangeboden",
    totalError: "Totaal fouten",
    totalVatExcl: "Excl. btw",
    totalCredit: "Totaal krediet",
    totalVatIncl: "Totaal",
    vatValue: "Waarde",
    totalBankTransfer: "Totaal overschrijving"
}

const orderedProductsString = {
    header: "Bestelgeschiedenis",
    accountId: "Rekening-ID",
    linkedTo: "Gekoppeld aan"
}

const accountHistory = {
    orderCode: "Code",
    payType: "Betaling",
    source: "Bron",
    header: "Rekeninggeschiedenis",
    filterShift: "Dienst #{shiftId}",
    filterUser: "Gebruiker #{userId}"
}

const openAccounts = {
    header: "Open rekeningen",
    type: "Type",
    source: "Bron",
    orderCode: "Bestelcode",
    covers: "Couverts",
    duration: "Duur"
}

const shiftDetail = {
    header: "Dienstdetail",
    referenceId: "Referentie"
}

const shiftStat = {
    header: "Dienststatistiek",
    sectionUsers: "Gebruikers",
    sectionUserShifts: "Diensten per gebruiker",
    sectionGroups: "Groepen",
    sectionParentGroups: "Oudergroepen",
    sectionProducts: "Producten",
    count: "Aantal",
    sales: "Verkopen",
    refund: "Terugbetalingen",
    correction: "Correcties",
    otherNeg: "Andere negatieve",
    purchasePrice: "Aankoopprijs",
    vatDetails: "Btw-detail",
    totalShifts: "Aantal diensten",
    userType: "Type",
    duration: "Duur",
    shift: "Dienst",
    autoClosed: "Automatisch gesloten"
}

const shift = {
    openShift: "Openingsuur",
    openUserName: "Gebruiker opening",
    openUserTime: "Openingsuur",
    openUserCash: "Startbedrag cash",
    closeUserName: "Gebruiker afsluiting",
    closeUserTime: "Sluitingsuur ",
    closeUserCash: "Eindbedrag cash",
    totalCash: "Cash",
    totalCard: "Kaart",
    totalOffered: "Aangeboden",
    totalBankTransfer: "Overschrijving",
    totalError: "Fout",
    totalCredit: "Krediet",
    statistics: "Statistieken",
    total: "Totaal dienst",
    inProgress: "Bezig...",
    endComment: "Eventuele opmerking bij het einde van de dienst",
    paymentType: "Rekening met gemengde betaling geforceerd afsluiten als",
    totalCashClose: "Je totale bedrag aan cash",
    HeaderShiftClose: "Deze dienst afsluiten",
    MessageCloseShift: "Weet je zeker dat je de dienst wil beëindigen? Je kan deze dienst daarna niet meer openen!",
    MessageOpenShift: "Weet je zeker dat je een nieuwe dienst wil openen?",
    noOpenShift: "Geen dienst bezig",
    OpenNewShift: "Een nieuwe dienst openen?",
    OpenNewShiftButton: "Een dienst openen",
    training: "Opleiding",
};

const printerStrings = {
    printers: "Printers",
    addPrinter: "Printer toevoegen",
    printerName: "Printernaam",
    doublePrint: "Dubbel afdrukken",
    model: "Model",
    modelUnset: "-- Selecteer een model --",
    modelHelper: "Model van de Star-printer. Optioneel — laat leeg indien onbekend.",
    erName: "Naam verplicht",
    erIpAddress: "IP-adres verplicht",
    modelGroup: {
        desktop: "Toonbank",
        compact: "Compact / keuken / kiosk",
        mobile: "Mobiel"
    },
    noPrinter: "Geen printer",
    noPrinterHint: "Voeg een printer toe om te beginnen.",
    editPrinter: "Printer bewerken",
}

const settingsPageStrings = {
    searchPlaceholder: "Zoek een instelling...",
    status: "Status van de organisatie",
    settings: "Instellingen",
    orderConfirmationEmailBccEnabled: "Bestelbevestigingen in BCC ontvangen",
    orderConfirmationEmailBccEnabledTooltip: "Schakel deze optie in om een blinde kopie (BCC) te ontvangen van alle bestelbevestigingen die naar klanten verstuurd worden.",
    hasImageBackground: "Productafbeelding heeft een achtergrond",
    printProductsSectionOnZReport: "Productsectie afdrukken op het Z-rapport",
    printProductsSectionOnZReportTooltip: "Neem de productsectie op in het Z-rapport wanneer de dienst afgesloten wordt.",
    digitalVatTicketEnabled: "Digitaal btw-ticket",
    digitalVatTicketEnabledTooltip: "Schakel het genereren van digitale btw-tickets in voor deze organisatie",
    printStatusUrlQrCode: "QR-code met bestelstatus afdrukken",
    printStatusUrlQrCodeTooltip: "Druk een QR-code af op tickets en kioskschermen zodat klanten de status van hun bestelling online kunnen volgen.",
    masterKioskOrgEnabled: "Master-kioskmodus",
    masterKioskOrgEnabledTooltip: "Laat kiosktoestellen wisselen tussen onderliggende organisaties (bv. handelaars in een foodcourt).",
    masterKioskIncludeMasterInPicker: "Masterorganisatie tonen in de kioskkeuze",
    masterKioskIncludeMasterInPickerTooltip: "Toon deze organisatie als keuzemogelijkheid in het wisselscherm van de kiosk, naast de onderliggende organisaties.",

    dataChangeLock: "Wijzigingen aan gegevens vergrendelen",
    dataChangeLockTooltip: "Wanneer dit is ingeschakeld, kunnen enkel super users de basisinstellingen van de organisatie wijzigen.",
    partnerSource: "Partnerbron",
    partnerSourceTooltip: "Bepaalt bij welke partner/verdeler deze organisatie hoort. Enkel super users met dezelfde partnerbron kunnen deze organisatie beheren; laat leeg voor een globaal beheerde organisatie.",
    supportChatCrispEnabled: "Crisp-supportchat",
    supportChatCrispEnabledTooltip: "Toont de Crisp-chatwidget aan deze organisatie zodat ze support rechtstreeks vanuit de app kan contacteren. Schakel uit om de widget voor deze klant te verbergen.",
    supportVipEnabled: "VIP-support",
    supportVipEnabledTooltip: "Markeert deze organisatie als prioritaire klant zodat hun supportvragen eerst behandeld worden.",
    kioskOrderActive: "Kioskbestellingen inschakelen",
    kioskOrderActiveTooltip: "Wanneer je deze optie inschakelt, kunnen klanten bestellen via de kiosk.",
    vwActivationMerchantApiKey: "Viva Wallet activatie merchant API-key",
    vwActivationMerchantApiSecret: "Viva Wallet activatie merchant API-secret",
    vwActivationPin: "Viva Wallet activatiepincode",
    shiftCounterEnabled: "Ticketteller per dienst inschakelen",
    shiftCounterEnabledTooltip: "Wanneer dit is ingeschakeld, worden de ticketnummers automatisch gereset aan het einde van elke dienst.",
    brandColors: "Merkkleuren",
    brandColor: "Merkkleur",
    brandSecondaryColor: "Secundaire merkkleur",
    brandTertiaryColor: "Tertiaire merkkleur",
    applyKioskBrandColors: "Merkkleuren toepassen op de kiosk",
    applyKioskBrandColorsTooltip: "Indien ingeschakeld, gebruikt de kiosk uw merkkleuren in plaats van het standaardthema.",
    onlineOrderVersion: "Versie online bestellen",
    bank: "Bank",
    suSectionOrganisation: "Organisatie",
    suSectionPeppol: "Peppol",
    suSectionKitchenDisplay: "Keukenscherm",
    suSectionDigitalMenu: "Digitaal menu",
    suSectionWebshop: "Webshop",
    suSectionGoogleMaps: "Google Maps",
    suSectionDeviceManagement: "Apparaatbeheer",
    suSectionShiftUser: "Diensten van medewerkers",
    suSectionParentOrganisation: "Moederorganisatie",
    bankIban: "IBAN",
    bankName: "Naam",
    bankBic: "BIC-code",
    peppolEnabled: "Peppol inschakelen",
    peppolEnabledTooltip: "Schakel de Peppol-integratie in om compatibele elektronische documenten te versturen en te ontvangen.",
    name: "Jouw organisatie",
    organisationId: "Organisatiecode",
    organisationName: "Naam",
    vatNumber: "Btw-nummer",
    digitalMenuEnabled: "Digitaal menu inschakelen",
    digitalMenuEnabledTooltip: "Schakel het digitale menu van deze organisatie in op de ondersteunde kanalen.",
    address: "Adres",
    searchAddress: "Zoek je adres (straat en nummer)",
    noAddressFound: "Geen adres gevonden",
    addressWithoutNumber: "Vermeld je huisnummer in de zoekopdracht",
    selectAddressFromList: "Kies je adres uit de suggesties",
    addressSearchUnavailable: "Adres zoeken is momenteel niet beschikbaar",
    telephone: "Telefoon",
    contactEmail: "Contact-e-mail",
    autoPrintVatTicketOnSend: "Btw-ticket automatisch afdrukken bij verzenden",
    autoPrintVatTicketOnSendTooltip: "Schakel in om het btw-ticket automatisch af te drukken nadat een bestelling verzonden is",
    website: "Website",
    mainPrinterIpAddress: "IP-adres hoofdprinter",
    takeawaySectionEnabled: "Afhaalsectie ingeschakeld",
    takeawaySectionEnabledTooltip: "Schakel een aparte afhaalsectie in op het startscherm.",
    tableSectionEnabled: "Tafelsectie ingeschakeld",
    tableSectionEnabledTooltip: "Schakel een aparte tafelsectie in op het startscherm.",
    shiftEnabled: "Diensten ingeschakeld",
    printerSettings: "Afdrukken",
    vivaWallet: "Viva Wallet",
    removeStockFromParentOrgHint: "Voorraad van de bovenliggende organisatie afboeken bij bestelling",
    removeStockFromParentOrgTooltip: "Schakel deze optie in om bij een bestelling automatisch voorraad af te boeken van de bovenliggende organisatie.",
    webSettings: "Instellingen webbestellingen",
    superSettings: "Super user",
    kitchenTopSpacing: "Bovenmarge keuken",
    kitchenTopSpacingTooltip: "Pas de ruimte boven de keukenzone aan voor meer visueel comfort.",
    kitchenGroupItems: "Keukenitems groeperen",
    kitchenGroupItemsTooltip: "Wanneer dit is ingeschakeld, worden keukenitems gegroepeerd voor een overzichtelijkere weergave.",
    charactersPerLine: "Tekens per regel",
    charactersPerLineTooltip: "Bepaal het maximale aantal tekens per afgedrukte regel.",
    bigKitchenFontSize: "Groot lettertype voor de keuken",
    bigKitchenFontSizeTooltip: "Vergroot het lettertype van de keuken voor een betere leesbaarheid.",
    pinLockTimeout: "Time-out pinvergrendeling (seconden)",
    promptCoversEnabled: "Aantal couverts vragen",
    promptCoversEnabledTooltip: "Bij het openen van een tafel of bestelling geeft het personeel het aantal gasten in.",
    pinLockEnabled: "Pinvergrendeling",
    kitchenPrintEnabled: "Bestelticket afdrukken",
    autoCloseAccountOnPaymentEnabled: "Rekening sluiten na betaling",
    kioskAutoCloseAccountOnPaymentEnabled: "Kioskbestellingen automatisch afsluiten na betaling",
    kioskAutoCloseAccountOnPaymentEnabledTooltip: "Bestellingen die aan de kiosk betaald zijn, worden meteen afgesloten in plaats van in de lijst met betaalde rekeningen te blijven.",
    onlineOrderAutoCloseAccountOnPaymentEnabled: "Online bestellingen automatisch afsluiten na betaling",
    onlineOrderAutoCloseAccountOnPaymentEnabledTooltip: "Webbestellingen die online betaald zijn, worden meteen afgesloten in plaats van in de lijst met betaalde rekeningen te blijven.",
    autoPrintSummaryTicketEnabled: "Ticket automatisch afdrukken na betaling",
    autoPrintKioskTooltip: "Druk automatisch een overzichtsticket af na een betaling op de kiosk",
    autoPrintOnlineOrderTooltip: "Druk automatisch een overzichtsticket af na een betaling op de webshop",
    autoPrintShiftXY: "Z automatisch afdrukken",
    hideShiftInfo: "Dienstinfo verbergen",
    paymentTypeOfferedEnabled: "Betaalmethode Aangeboden toestaan",
    paymentTypeTransferEnabled: "Betaalmethode Overschrijving toestaan",
    sendOrderBehavior: "Actie na verzenden",
    autoOpenCashRegister: "Kassalade automatisch openen",
    DEFAULT: "STANDAARD",
    NAV_BACK: "TERUG",
    NAV_PAYMENT: "NAAR BETALING",
    orgaFlag: "App",
    refundEnabled: "Terugbetaling toestaan",
    addItemsToTop: "Nieuw product bovenaan",
    autoOpenNewAccount: "Automatisch een nieuwe rekening openen",
    normalAccountOpenButton: "Gewone '+'-knop om een rekening te openen",
    vwIsvAmount: "ISV-bedrag",
    vwEnabled: "VW ingeschakeld",
    vwTerminalMerchantId: "ISV merchant-ID",
    vwTerminalId: "Terminal-ID (voor NEXT-terminals)",
    mapsAutoCompleteEnabled: "Google Maps-integratie",
    autoAssignDeviceToMainType: "Toestel automatisch aan het hoofdtype toewijzen",
    workerShiftsEnabled: "Gebruikersdiensten inschakelen (werktijd)",
    pinLockTooltip: "Vraag een pincode om toegang te krijgen tot de app",
    shiftsTooltip: "Schakel het dienstensysteem in: de gebruiker moet een dienst openen voor hij de app gebruikt en die afsluiten aan het einde van elke dienst",
    printOrderTicketTooltip: "Schakel het afdrukken van een ticket in wanneer een bestelling naar de keuken gestuurd wordt",
    closeAccountAfterPaymentTooltip: "Sluit de rekening automatisch na een betaling",
    autoPrintSummaryTicketTooltip: "Druk automatisch een overzichtsticket af na een betaling",
    autoPrintSummaryOnCashOrderKiosk: "Druk het ticket automatisch af na een cashbetaling op de kiosk",
    autoPrintSummaryOnCashOrderOnlineOrder: "Druk het ticket automatisch af na een cashbetaling op de webshop",
    allowOfferTooltip: "Schakelt de knop 'Aanbieden' in op het betaalscherm voor ALLE gebruikers",
    actionAfterSendTooltip: `Kies wat er gebeurt nadat een bestelling naar de keuken gestuurd is: 
 - STANDAARD: op het bestelscherm blijven 
 - TERUG: terug naar het bestelscherm 
 - NAAR BETALING: naar het betaalscherm gaan`,
    openCashRegisterTooltip: "Open de kassalade automatisch bij de bevestiging van een cashbetaling",
    autoPrintShiftXZTooltip: "Druk de X/Z automatisch af op de printer wanneer de dienst in de app afgesloten wordt",
    hideShiftInfoTooltip: "Verberg de dienstinformatie zoals de betaalwijze en het totaalbedrag van de dienst op de pagina voor dienstbeheer in de app",
    allowBankTransferTooltip: "Schakel de betaalwijze overschrijving in op het betaalscherm voor ALLE gebruikers",
    allowRefundTooltip: "Schakel de terugbetaalknop in op een rekening uit de geschiedenis voor ALLE gebruikers",
    newProductOnTopTooltip: "Wanneer dit is ingeschakeld, verschijnt een product dat aan een rekening/tafel toegevoegd wordt bovenaan de lijst in plaats van onderaan",
    autoOpenNewAccountTooltip: "Open automatisch een nieuwe rekening zodra de vorige gesloten is. Zo kan je meteen verder bestellen na het afsluiten van de vorige rekening.",
    separateInDeliveryTakeawayTooltip: `Uitgeschakeld: er verschijnen 2 soorten knoppen om een rekening te openen op het startscherm, levering/afhaal en tafel.
     Ingeschakeld: er is enkel een '+'-knop om een nieuwe rekening te openen`,
    subSectionPayment: "Betaling",
    subSectionHome: "Startscherm",
    subSectionShift: "Dienst",
    subSectionOrdering: "Bestellen",
    subSectionWebsite: "Website",
    mainPrinterTooltip: "Het IP-adres van de hoofdprinter waarop standaard alle tickets afgedrukt worden",
    pinLockTimeoutTooltip: "De tijd in seconden voordat de pinvergrendeling actief wordt. Dit werkt enkel als de pinvergrendeling ingeschakeld is",
    includeParentProductsHint: "Producten van de bovenliggende organisatie meenemen",
    includeParentProductsTooltip: "Neemt de producten van de bovenliggende organisaties op, ENKEL in de app, als deze organisatie een bovenliggende organisatie heeft",
    parentOrgId: "ID bovenliggende organisatie",
    parentOrgIdTooltip: "Bepaalt de bovenliggende organisatie waarvan bepaalde instellingen, producten of gedragingen overgenomen worden.",
    onlineOrderWebPageEnabled: "Online bestellen geactiveerd",
    onlineOrderWebPageEnabledTooltip: "Schakel de webshop voor online bestellen in voor deze organisatie.",
    onlineOrderOpen: "Online bestellen open",
    onlineOrderOpenTooltip: "Zet het aannemen van bestellingen op de webshop tijdelijk aan of uit zonder de volledige bestelsite uit te schakelen.",
    onlineOrderDeliveryEnabled: "Levering ingeschakeld",
    onlineOrderDeliveryEnabledTooltip: "Laat klanten levering kiezen als bestelwijze op de webshop.",
    onlineOrderPickupEnabled: "Afhalen ingeschakeld",
    onlineOrderPickupEnabledTooltip: "Laat klanten afhalen kiezen als bestelwijze op de webshop.",
    payOnlineEnabled: "Online betalen ingeschakeld",
    payOnlineEnabledTooltip: "Schakel online betalen in tijdens het afrekenen op de webshop.",
    payAtPickupEnabled: "Betalen na bestelling (bij afhaling) ingeschakeld",
    payAtPickupEnabledTooltip: "Laat klanten bij afhaling of levering betalen in plaats van online bij het plaatsen van de bestelling.",
    onlineOrderHideNoStockProducts: "Enkel producten met beschikbare voorraad tonen",
    onlineOrderHideNoStockProductsTooltip: "Verberg producten zonder voorraad op de webshop.",
    logoImageUrl: "Logo",
    logoImageUrlTooltip: "Het logo van je organisatie. Upload een PNG of plak de URL.",
    ticketLogoImageUrl: "Ticketlogo (png)",
    ticketLogoImageUrlTooltip: "Logo dat op de tickets wordt afgedrukt. Upload een PNG of plak de URL.",
    bannerImageUrl: "Banner",
    bannerImageUrlTooltip: "Banner op je online shop. Upload een afbeelding of plak de URL.",
    hideProductImagesInApp: "Afbeeldingen verbergen in de APP",
    hideProductImagesInAppTooltip: "Als je afbeeldingen aan je producten toegevoegd hebt, laat dit toe ze niet te tonen in de posbel-app, terwijl ze zichtbaar blijven voor je QR-CODE/KIOSK/...",
    webOrgaName: "Naam van de organisatie voor de website",
    autoPrintSummaryTicketOnSend: "Overzichtsticket automatisch afdrukken na het verzenden van een bestelling",
    autoPrintSummaryTicketOnSendTooltip: "Schakel in om het overzichtsticket automatisch af te drukken wanneer een bestelling verzonden wordt",
    autoPrintVatTicket: "Btw-ticket automatisch afdrukken",
    autoPrintVatTicketTooltip: "Schakel in om het btw-ticket altijd automatisch af te drukken na een betaling",
    subscriptionEnd: "Einde abonnement",
    subscriptionEndTooltip: "Bepaalt de datum en het uur waarop het abonnement van de organisatie afloopt.",
    onlineOrderMinAmount: "Minimumbedrag voor online bestellen",
    onlineOrderMinAmountTooltip: "Minimaal bestelbedrag dat klanten nodig hebben om een webshopbestelling te bevestigen.",
    onlineOrderPromoCodeInputEnabled: "Promocodeveld",
    onlineOrderPromoCodeInputEnabledTooltip: "Toont het invoerveld voor de promocode op de webshop bij het bevestigen van de bestelling.",
    onlineOrderExecutionTimeInputEnabled: "Keuze van besteltijd",
    onlineOrderExecutionTimeInputEnabledTooltip: "Laat de klant het uitvoeringstijdstip van de bestelling kiezen op de webshop.",
    onlineOrderExecutionTimeEatInEnabled: "Tijdkeuze ter plaatse",
    onlineOrderExecutionTimeEatInEnabledTooltip: "Laat ook voor bestellingen ter plaatse het uitvoeringstijdstip kiezen.",
    onlineOrderMinExecutionDelayMinutes: "Minimale uitvoeringstermijn (minuten)",
    onlineOrderMinExecutionDelayMinutesTooltip: "Minimale termijn in minuten tussen de bevestiging van de bestelling en het vroegste aangeboden uitvoeringstijdstip.",
    accountBankName: "Bankrekening",
    eatInEnabled: "Ter plaatse",
    eatInEnabledTooltip: "Laat klanten ter plaatse eten kiezen als bestelwijze op de webshop.",
    autoGroupingEnabled: "Producten groeperen inschakelen",
    autoGroupingEnabledTooltip: "Wanneer dit is ingeschakeld, worden opeenvolgend bestelde items automatisch samengevoegd tot één regel (bv. 3 × Item A) voor een overzichtelijkere weergave.",
    onlineOrderBankTransferEnabled:"Betalen via overschrijving",
    onlineOrderBankTransferEnabledTooltip: "Sta overschrijving toe als betaalwijze voor webshopbestellingen.",
    kiosk: "Kiosk",
    kioskBackgroundVideoUrl: "URL achtergrondvideo",
    kioskBackgroundVideoUrlTooltip: "Video die op de achtergrond van de kiosk wordt afgespeeld. Upload een MP4 of plak de URL.",
    customWebshopDomain: "Aangepast websitedomein",
    customWebshopDomainTooltip: "Ken een eigen domeinnaam toe aan de webshop van deze organisatie.",
    shiftAutoOpen: "Automatische opening van de dienst",
    shiftAutoOpenTooltip: "Schakel deze optie in om je dienst automatisch te openen",
    shiftAutoClose: "Automatische afsluiting van de dienst",
    shiftAutoCloseTooltip: "Schakel deze optie in om je dienst automatisch af te sluiten",
    showShiftHours: "Automatische sluitingsuren instellen",
    uiStateOrderProductGroupDoubleCols: "Groepen in twee kolommen tonen",
    uiStateOrderProductGroupDoubleColsTooltip: "Wanneer dit is ingeschakeld, worden de productgroepen op je kassa in twee kolommen getoond in plaats van één.",
    kitchenDisplayEnabled: "Keukenscherm inschakelen",
    kitchenDisplayEnabledTooltip: "Schakel het keukenscherm in om bestellingen in bereiding te tonen voor deze organisatie.",
    kitchenDisplayAutoPrintOnStateChange: "Automatisch afdrukken wanneer een bestelling klaar is",
    kitchenDisplayAutoPrintOnStateChangeTooltip: "Wanneer dit is ingeschakeld, wordt er automatisch een ticket afgedrukt zodra een bestelling de status 'Klaar' bereikt.",
    kitchenDisplayPreparingStateEnabled: "Bereidingssectie inschakelen",
    kitchenDisplayPreparingStateEnabledTooltip: "Wanneer dit is ingeschakeld, wordt er een sectie 'In bereiding' getoond met de bestellingen die momenteel klaargemaakt worden.",
    kioskOrderNameRequired: "Naam van de klant vragen",
    kioskOrderNameRequiredTooltip: "Wanneer dit is ingeschakeld, verschijnt er een veld om de naam van de klant op het bestelticket te zetten",
    kioskBuzzerNumberRequired: "Buzzernummer vragen",
    kioskBuzzerNumberRequiredTooltip: "Wanneer dit is ingeschakeld, verschijnt er een veld om het buzzernummer op het bestelticket te zetten",
    active: "Actief",
    blocked: "Geblokkeerd",
    behindPayment: "Betalingsachterstand",
    inactive: "Inactief",
    statusTooltip: "Bepaalt of de organisatie actief of geblokkeerd is in het systeem.",
    printPhoneOnTicket: "Telefoonnummer op het ticket afdrukken",
    printPhoneOnTicketTooltip: "Druk het telefoonnummer van de organisatie af op proforma- en btw-tickets",
    ticketHeaderText: "Koptekst ticket",
    ticketHeaderTextTooltip: "Tekst die bovenaan elk ticket wordt afgedrukt, boven de besteldetails. Gebruik dit voor een welkomstbericht of uw openingsuren. Maximaal 500 tekens.",
    ticketFooterText: "Voettekst ticket",
    ticketFooterTextTooltip: "Tekst die onderaan elk ticket wordt afgedrukt, onder het totaal. Gebruik dit om klanten te bedanken of uw website te vermelden. Maximaal 500 tekens.",
    compressedTicketsEnabled: "Gecomprimeerde tickets",
    compressedTicketsEnabledTooltip: "Druk tickets af in een compacte lay-out om papier te besparen voor deze organisatie.",
    showDefaultOptionsDescription: "Standaardopties tonen (kiosk/web)",
    showDefaultOptionsDescriptionTooltip: "Wanneer dit is ingeschakeld, worden de optiegroepen van het product onder de productnaam getoond. Dit geldt enkel voor bestellingen via kiosk/web. Bij de kassa worden de standaardopties getoond.",
    onlineOrderVersionTooltip: "Kies de versie die je wil gebruiken voor je systeem voor online bestellen.",
    hasImageBackgroundTooltip: "Bepaalt de stijl van de afbeelding voor een betere weergave op de webshop",
    vwEnabledTooltip: "Schakel de Viva Wallet-integratie in voor deze organisatie.",
    vwIsvAmountTooltip: "ISV-bedrag of -tarief dat gebruikt wordt in de Viva Wallet-configuratie van deze organisatie.",
    vwTerminalMerchantIdTooltip: "Merchant-identificatie die deze organisatie aan haar Viva Wallet-account koppelt.",
    vwTerminalIdTooltip: "Viva Wallet terminal-identificatie voor cloud-/NEXT-betalingen.",
    vwActivationMerchantApiKeyTooltip: "Merchant API-key om Viva Wallet-terminals te activeren.",
    vwActivationMerchantApiSecretTooltip: "Merchant API-secret om Viva Wallet-terminals te activeren.",
    vwActivationPinTooltip: "Activatiepincode van Viva Wallet om de terminal te initialiseren.",
    orgTypeTooltip: "Bepaalt de belangrijkste activiteit van de organisatie om bepaalde gedragingen en weergaven aan te passen.",
    mapsAutoCompleteEnabledTooltip: "Schakel de Google Maps-integratie in voor automatische adresaanvulling en locatiehulp.",
    autoAssignDeviceToMainTypeTooltip: "Wijs nieuwe toestellen automatisch toe aan het hoofdtype dat voor deze organisatie ingesteld is.",
    workerShiftsEnabledTooltip: "Schakel het opvolgen van gebruikersdiensten en het prikkloksysteem in voor deze organisatie.",
    webOrgaNameTooltip: "Identificatie of naam die de webshopsite gebruikt om deze organisatie te herkennen.",
    blackbox: "Blackbox",
    fdmPosId: "Pos Id",
    fdmUrl: "FDM-URL",
    blackboxFdmId: "FDM-ID",
    blackboxBasicAuth: "FDM Basic Auth",
    blackboxEstablishmentNumber: "Vestigingsnummer",
    generateCodeQrTooltip: "Download de QR-code die naar je bestelsite leidt.",
};

const deliveryAreaPageStrings = {
    title: "Leveringszones",
    newArea: "Nieuwe zone",
    createArea: "Een zone aanmaken",
    addDeliveryArea: "Een leveringszone toevoegen",
    editArea: "Zone bewerken",
    areas: "Zones",
    noAreas: "Nog geen leveringszone. Teken je eerste zone op de kaart.",
    drawHint: "Klik op de kaart om de punten van je zone te plaatsen.",
    cancelDrawing: "Annuleren",
    finishDrawing: "Zone voltooien",
    undoPoint: "Laatste punt verwijderen",
    name: "Naam van de zone",
    namePlaceholder: "Bv. Stadscentrum",
    price: "Leveringsprijs (incl. btw)",
    minOrderAmount: "Minimaal bestelbedrag",
    freeDeliveryMinAmount: "Minimumbedrag voor gratis levering",
    defaultFromSettingsHint: "Laat op 0 om het bedrag uit de organisatie-instellingen te gebruiken.",
    amountInvalid: "Het bedrag moet groter dan of gelijk aan 0 zijn.",
    orderIndex: "Prioriteitsvolgorde",
    orderIndexHint: "Hoe lager het nummer, hoe hoger de prioriteit wanneer zones elkaar overlappen.",
    orderIndexInvalid: "De prioriteitsvolgorde moet een positief geheel getal zijn.",
    editShapeHint: "Verplaats de punten van de geselecteerde zone rechtstreeks op de kaart.",
    shapeModified: "Vorm gewijzigd",
    saveShape: "Vorm opslaan",
    resetShape: "Wijzigingen annuleren",
    minPoints: "Een zone moet minstens 3 punten bevatten.",
    nameRequired: "De naam van de zone is verplicht.",
    priceInvalid: "De prijs moet groter dan of gelijk aan 0 zijn.",
    mapError: "De kaart kon niet worden geladen.",
    points: "punten",
    searchAddressMode: "Adres",
    searchZoneMode: "Gemeente",
    searchAddressPlaceholder: "Zoek een adres",
    searchZonePlaceholder: "Postcode of gemeente (bv. 1140, 1930)",
    surroundZone: "Omlijnen",
    removeZoneQuery: "Verwijderen",
    zoneAlreadyAdded: "Zone al toegevoegd:",
    zoneNotFound: "Geen omtrek gevonden voor:",
    searchFailed: "De zoekopdracht is mislukt.",
    zonesFound: "Omtrekken gevonden",
    discardZones: "Annuleren",
    keepZones: "Aanmaken",
    createAreas: "Zones aanmaken",
    batchHint: "Er wordt één zone per gemeente aangemaakt, met dezelfde bedragen."
};

const invoicePageStrings = {
    emptyTable: "Geen facturen gevonden.",
    invoiceNumber: 'Factuurnr.',
    linkedTicket: 'Gekoppeld ticket',
    type: 'Type',
    standard: 'Standaard',
    markAsPaid: 'Markeren als betaald',
    sentReminder: 'Herinnering versturen',
    paid: 'Betaald',
    waiting: 'In afwachting',
    lastReminder: 'Laatste herinnering',
    markPaidQuestion: 'Wil je deze factuur als betaald markeren?',
    invoice: 'Factuur',
    editInvoice: "Factuur bewerken",
};

const promoPageStrings = {
    emptyTable: "Geen promotiecodes gevonden.",
    addPromo: "Promotie toevoegen",
    promoCode: 'Promocode',
    discountAmount: "Bedrag",
    maxUses: "Max gebruik",
    usedCount: 'Aantal keer gebruikt',
    erPromoCode: 'Ongeldige promocode',
    erPromoCode2: 'De promocode mag enkel letters en cijfers bevatten',
    erMaxUses: 'Het maximale aantal gebruiken is verplicht',
    erDiscountAmount: 'Het kortingsbedrag moet groter zijn dan 0',
    erUsedCount: 'Het aantal keer gebruikt is verplicht',
    validityPeriod: "Geldigheidsperiode",
    erValidityPeriod: "Selecteer een begin- en einddatum",
    erMAmount: "M moet een positief geheel getal zijn",
    erNAmount: "N moet een positief geheel getal zijn",
    type: "Type",
    percentage: "Percentage",
    fixed: "Vast",

    nAmount: "Bedrag (N)",
    nAmountTooltip: "Aantal items dat gratis gegeven wordt na de aankoop van M items.",

    mAmount: "Bedrag (M)",
    mAmountTooltip: "Aantal items dat de klant in het winkelmandje moet leggen om van de promotie te genieten.",

    applyGroupId: "Toepassen op een productgroep",
    applyGroupIdTooltip: "Als er geen groep gekozen is, geldt de promotie voor alle productgroepen.",

    autoActivate: "Auto activering",
    autoActivateTooltip: "Past deze promotie automatisch toe in het winkelmandje zonder promocode (ook bij het afrekenen).",

    mPlusNSamePrice: "M+N zelfde prijs",
    editPromo: "Promo bewerken",
};

const voucherPageStrings = {
    title: 'Bonnen',
    createVouchers: "Bonnen aanmaken",
    noVoucherFound: 'Geen bon gevonden.',

    code: 'Code',
    value: 'Waarde',
    remainingValue: 'Resterend saldo',
    expiryDate: 'Vervaldatum',
    email: 'E-mail',
    productGroups: 'Toegelaten groepen',
    status: 'Status',
    createdAt: 'Aangemaakt op',
    noExpiry: 'Geen vervaldatum',

    statusActive: 'Actief',
    statusRevoked: 'Ingetrokken',
    statusExpired: 'Vervallen',
    statusDepleted: 'Opgebruikt',
    statusPartiallyUsed: 'Gedeeltelijk gebruikt',

    quantity: 'Hoeveelheid',
    quantityTooltip: 'Aantal bonnen dat in deze reeks aangemaakt wordt (1 tot 500).',
    valueTooltip: 'Bedrag dat op elke bon van de reeks geladen wordt.',
    expiryDateTooltip: 'Laat leeg voor een bon die nooit vervalt.',
    emailTooltip: 'Enkel informatief: aan wie de bon gegeven werd. Er wordt geen e-mail verstuurd.',
    productGroupsTooltip: 'Beperk de bon tot deze productgroepen. Laat leeg om het volledige assortiment toe te laten.',
    valueLockedTooltip: 'Het bedrag kan niet meer gewijzigd worden: deze bon werd al gebruikt.',

    createdBatchTitle: 'Bonnen aangemaakt',
    createdBatchSubtitle: 'De codes zijn gegenereerd. Download nu de afdrukbare kaarten.',
    downloadPdf: 'Pdf downloaden',
    downloadSelectionPdf: 'De kaarten van de selectie downloaden',
    downloadAllPdf: 'Alle kaarten downloaden',
    noVoucherToDownload: 'Geen voucher om te downloaden',
    close: 'Sluiten',

    activeToggle: 'Actief',
    activeToggleTooltip: 'Een ingetrokken bon blijft zichtbaar maar kan niet meer gebruikt worden.',
    redemptions: 'Gebruiksgeschiedenis',
    noRedemption: 'Deze bon werd nog nooit gebruikt.',
    redemptionRemainingAfter: 'Saldo nadien',
    viewAccount: 'Bestelling bekijken',

    erQuantity: 'De hoeveelheid moet tussen 1 en 500 liggen',
    erValue: 'Het bedrag moet groter zijn dan 0',
    erEmail: 'Ongeldig e-mailadres',
    errorPdf: 'De pdf kon niet gegenereerd worden',
    deleteConfirm: 'Deze bon wordt uit de lijst verwijderd en kan niet meer gebruikt worden. Deze actie kan niet ongedaan gemaakt worden.'
};

const pickupPageStrings = {
    addPickup: "Afhaalpunt toevoegen",
    notFound: 'Geen afhaalpunt gevonden.',
    name: 'Naam',
    address: "Adres",
    phone: "Telefoon",
    openingHours: "Besteluren",
    hoursField: "Tijdsloten",
    pickupTime: "Afhaaluur",
    type: "Type",
    day: "Dag",
    hour: "Start",
    hour2: "Einde",
    add: "Toevoegen",
    erName: "Naam verplicht",
    erPhone: "Telefoonnummer verplicht",
    erPhone2: "Ongeldig telefoonnummer",
    erAddress: "Adres verplicht",
    erSlot: "Voeg een tijdslot toe",
    editPickup: "Pickup bewerken",
};

const deviceStrings = {
    emptyTable: "Geen apparaten gevonden.",
    serialNumber: "Serienummer",
    model: "Model",
    brand: "Merk",
    osVersion: "OS-versie",
    appVersion: "App-versie",
    lastUsedUser: "Laatste gebruiker",
    boundUser: "Gekoppelde gebruiker",
    device: "Toestel",
    deleteAll: "Alle toestellen verwijderen",
}

const websitePageStrings = {
    general: "Algemeen",
    image: "Afbeeldingen",
}

const aiDebuggerStrings = {
    title: "Posbel AI",
    investigationStarted: "Onderzoek gestart",
    requestType: "Type onderzoek",
    message: "Beschrijving van het probleem",
    messageTooltip: "Verplicht voor “Ander probleem”. Voor de andere types een optioneel detail over het incident.",
    moreOptions: "Meer opties",
    orgId: "Organisatie-id",
    orgIdTooltip: "Laat leeg om de huidige organisatie te onderzoeken.",
    targetUser: "Betrokken gebruiker",
    targetUserId: "Id van de betrokken gebruiker",
    targetUserTooltip: "De kassa- of bedieningsaccount waarop het incident gebeurde. Die moet tot de onderzochte organisatie behoren.",
    accountId: "Rekening-id",
    orderCode: "Bestelcode",
    transactionId: "Transactie-id",
    paymentTransactionId: "Betalingstransactie-id",
    deviceId: "Toestel-id",
    printerId: "Printer-id",
    timeRange: "Periode",
    timeRangeTooltip: "Zonder periode worden de laatste 24 uur geanalyseerd (7 dagen voor “Recente menuwijzigingen”).",
    techMode: "Technische modus",
    techModeDescription: "Een technischer rapport, bedoeld voor ontwikkelaars.",
    launch: "Onderzoek starten",
    newInvestigation: "Nieuw onderzoek",
    investigations: "Mijn onderzoeken",
    noInvestigation: "Geen onderzoek",
    noInvestigationHint: "Onderzoeken worden 7 dagen bewaard.",
    showReport: "Rapport bekijken",
    showError: "Fout bekijken",
    hideDetails: "Verbergen",
    downloadReport: "Rapport downloaden",
    downloadError: "De pdf kon niet worden aangemaakt.",
    pdfTitle: "Posbel technisch onderzoek",
    pdfInvestigation: "Onderzoek",
    pdfStatus: "Status",
    pdfRequestedBy: "Aangevraagd door",
    pdfCreatedAt: "Aangemaakt op",
    pdfCompletedAt: "Afgerond op",
    reportEmpty: "Het rapport is leeg.",
    requestTypes: {
        PAYMENT_NOT_SENT_TO_TERMINAL: "Betaling niet naar de terminal gestuurd",
        KITCHEN_PRINTING_NOT_WORKING: "Keukenprinten werkt niet",
        VAT_SUMMARY_TICKETS_NOT_PRINTING: "Btw- / overzichtstickets worden niet afgedrukt",
        PAYMENT_NOT_REGISTERED: "Betaling niet geregistreerd",
        RECENT_MENU_CHANGES: "Recente menuwijzigingen",
        OTHER: "Ander probleem",
    },
};

const playlistStrings = {
    loadError: "Playlists kunnen niet worden geladen",
    disabledHint: "Het digitale menu is niet ingeschakeld voor deze organisatie.",
    unavailableTitle: "Digitaal menu niet beschikbaar",
    mediaType: "Mediatype",
    groupSectionLabel: "Sectie {index}",
    editPlaylist: "Playlist bewerken",
    editScene: "Scène bewerken",
    noScene: "Geen scène in deze playlist",
    sceneCount: "{count} scène | {count} scènes",
    columnLabel: "Kolom {index}",
    columnHeader: "Kolomkop",
    columnSectionCount: "{count} sectie | {count} secties",
    columnEmpty: "Voeg een sectie toe om deze kolom te vullen.",
    typeImage: "Afbeelding",
    typeVideo: "Video",
    typeMenu: "Menu",
    name: "Naam",
    transitionDuration: "Duur van de overgang (sec)",
    transitionType: "Type overgang",
    fade: "Vervagen",
    slide: "Schuiven",
    addPlaylist: "Afspeellijst toevoegen",
    addScene: "Scène toevoegen",
    playlist: "Afspeellijst",
    productGroups: "Productgroepen",
    orderIndex: "Volgorde",
    duration: "Weergaveduur",
    contentType: "Type inhoud",
    templateName: "Thema",
    backgroundType: "Type achtergrond",
    background: "URL achtergrond",
    vertical: "Verticale tv",
    template4Config: {
        chipsHeader: "Titelbalk",
        chipsTheme: "Thema",
        chipsLayout: "Lay-out",
        chipsColumns: "Kolommen",
        chipsTypography: "Typografie",
        chipsStyle: "Stijl",
        subtitleStructure: "Structuur",
        subtitleSpacing: "Tussenruimte",
        subtitleOffsets: "Marges",
        subtitleAlignment: "Uitlijning",
        subtitleCardPreset: "Kaartvoorinstelling",
        subtitleVisibility: "Zichtbaarheid",
        subtitleMainHeader: "Hoofdtitel",
        subtitleColumnHeader: "Kolomtitel",
        subtitleMenuContent: "Inhoud van het menu",
        subtitleColorSection: "Kleur",
        title: "Titel",
        titleTooltip: "Hoofdtitel die boven het menu getoond wordt.",
        subtitle: "Ondertitel",
        subtitleTooltip: "Tweede regel onder de hoofdtitel.",
        headerColumns: "Kolommen van de titelbalk",
        headerColumnsTooltip: "Kies of de hoofdtitel enkel de eerste kolom gebruikt of over de eerste twee loopt.",
        firstColumnOnly: "Enkel de eerste kolom",
        firstTwoColumns: "De eerste twee kolommen",
        headerBottomSpacing: "Ruimte onder de titelbalk",
        headerBottomSpacingTooltip: "Verticale ruimte tussen de hoofdtitel en het begin van de kolominhoud.",
        headerAlign: "Uitlijning van de titelbalk",
        headerAlignTooltip: "Horizontale uitlijning van de tekst van de hoofdtitel.",
        titleSize: "Grootte van de titel",
        titleSizeTooltip: "Lettergrootte van de hoofdtitel.",
        subtitleSize: "Grootte van de ondertitel",
        subtitleSizeTooltip: "Lettergrootte van de ondertitel van de hoofdtitel.",
        titleColor: "Kleur van de titel",
        titleColorTooltip: "Tekstkleur van de hoofdtitel.",
        subtitleColor: "Kleur van de ondertitel",
        subtitleColorTooltip: "Tekstkleur van de ondertitel van de hoofdtitel.",
        columnTitleColor: "Kleur van de kolomtitel",
        columnTitleColorTooltip: "Tekstkleur van de titels per kolom.",
        columnSubtitleColor: "Kleur van de kolomondertitel",
        columnSubtitleColorTooltip: "Tekstkleur van de ondertitels per kolom.",
        backgroundColor: "Achtergrondkleur",
        backgroundColorTooltip: "Achtergrondkleur van het volledige sjabloon.",
        textColor: "Tekstkleur",
        textColorTooltip: "Standaard tekstkleur in de inhoud van het menu.",
        groupBackground: "Achtergrond van de groep",
        groupBackgroundTooltip: "Basiskleur voor de achtergrond van de groepskaarten.",
        accentColor: "Accentkleur",
        accentColorTooltip: "Accentkleur voor accenten, titels en prijzen.",
        language: "Taal",
        languageTooltip: "Taal die gebruikt wordt om de vertaalde productbeschrijvingen te kiezen.",
        contentPadding: "Binnenmarge van de inhoud",
        contentPaddingTooltip: "Binnenmarge rond alle inhoud van het menu.",
        showPrices: "Prijzen tonen",
        showPricesTooltip: "Toon of verberg de productprijzen.",
        showEuroSymbol: "€-symbool tonen",
        showEuroSymbolTooltip: "Toon of verberg het euroteken naast de prijzen.",
        showDots: "Stippellijn tonen",
        showDotsTooltip: "Toon een stippellijn tussen de productnaam en de prijs.",
        showDescriptions: "Beschrijvingen tonen",
        showDescriptionsTooltip: "Toon of verberg de productbeschrijvingen onder de productnamen.",
        showProductImage: "Productafbeelding tonen",
        showProductImageTooltip: "Toon een vierkante productafbeelding op elke productregel wanneer die beschikbaar is.",
        productImageSize: "Grootte van de productafbeelding",
        productImageSizeTooltip: "Vierkante grootte in pixels voor de productafbeeldingen (breedte en hoogte).",
        productCardStyle: "Stijl van de productkaart",
        productCardStyleTooltip: "Visuele voorinstelling voor de weergave van groeps- en productkaarten.",
        columns: "Kolommen",
        columnsTooltip: "Totaal aantal kolommen in het sjabloon.",
        columnGap: "Ruimte tussen kolommen",
        columnGapTooltip: "Horizontale ruimte tussen de kolommen.",
        groupSpacing: "Ruimte tussen groepen",
        groupSpacingTooltip: "Verticale ruimte tussen de groepen binnen één kolom.",
        leftEmptySpace: "Lege ruimte links",
        leftEmptySpaceTooltip: "Gereserveerde lege ruimte links, voor de kolommen beginnen.",
        rightEmptySpace: "Lege ruimte rechts",
        rightEmptySpaceTooltip: "Gereserveerde lege ruimte rechts, na de kolommen.",
        columnHeaderSpacing: "Ruimte onder de kolomtitel",
        columnHeaderSpacingTooltip: "Ruimte tussen de titel van een kolom en de eerste groep van die kolom.",
        columnHeaderAlign: "Uitlijning van de kolomtitel",
        columnHeaderAlignTooltip: "Horizontale uitlijning van de titel en ondertitel per kolom.",
        left: "Links",
        center: "Gecentreerd",
        right: "Rechts",
        classic: "Klassiek",
        modern: "Modern",
        minimal: "Minimaal",
        compact: "Compact",
        clean: "Clean",
        framed: "Omkaderd",
        addColumn: "Kolom toevoegen",
        columnHeaderSection: "Kolomtitel",
        showColumnHeader: "Titelblok tonen",
        showColumnHeaderTooltip: "Schakel het titel-/ondertitelblok voor deze specifieke kolom in of uit.",
        columnTitle: "Titel van de kolom",
        columnTitleTooltip: "Titel die boven deze kolom getoond wordt.",
        columnSubtitle: "Ondertitel van de kolom",
        columnSubtitleTooltip: "Ondertitel onder de titel van de kolom.",
        groupSection: "Groepssectie",
        productGroup: "Productgroep",
        productGroupTooltip: "Kies welke productgroep in deze sectie getoond wordt.",
        selectProductGroup: "Kies een productgroep",
        visibleProducts: "Zichtbare producten",
        visibleProductsTooltip: "Kies welke producten van de geselecteerde groep in deze sectie getoond worden.",
        selectVisibleProducts: "Kies de zichtbare producten",
        addGroupSection: "Groepssectie toevoegen",
        columnTitleSize: "Grootte van de kolomtitel",
        columnTitleSizeTooltip: "Lettergrootte van de titels per kolom.",
        columnSubtitleSize: "Grootte van de kolomondertitel",
        columnSubtitleSizeTooltip: "Lettergrootte van de ondertitels per kolom.",
        groupSize: "Grootte van de groep",
        groupSizeTooltip: "Lettergrootte van de groepstitels.",
        productSize: "Grootte van het product",
        productSizeTooltip: "Lettergrootte van de productnamen.",
        descriptionSize: "Grootte van de beschrijving",
        descriptionSizeTooltip: "Lettergrootte van de productbeschrijvingen."
    }
}

const topBarStrings = {
    searchPlaceholder: "Zoeken, navigeren, handelen...",
    interfaceSettings: "Interface-instellingen",
    openMenu: "Menu openen",
    account: "Mijn account",
    testEnvironment: "Testomgeving"
};

const preferencesPageStrings = {
    showTableIds: "Identificatoren tonen",
    showTableIdsTooltip: "Toont een kolom met de technische identificator in tabellen. Alleen zichtbaar voor superusers.",
    name: "Interface",
    description: "Deze instellingen zijn eigen aan deze browser en worden lokaal bewaard.",
    favorites: "Favorieten",
    favoriteLinks: "Favoriete links",
    favoriteLinksTooltip: "De gekozen pagina's verschijnen in een sectie Favorieten bovenaan het zijmenu.",
    language: "Taal van de interface",
    languageTooltip: "Taal van het beheer, los van die van de browser.",
    languageAuto: "Automatisch",
    languageNl: "Nederlands",
    languageFr: "Français",
    languageEn: "English",
    sideNavAlwaysExpanded: "Het zijmenu open houden",
    sideNavAlwaysExpandedTooltip: "Het zijmenu blijft uitgeklapt in plaats van automatisch dicht te klappen."
};

const createOrgPageStrings = {
    validation: {
        name: "De naam van de organisatie is verplicht",
        contactEmail: "Een geldig e-mailadres is verplicht",
        orgType: "Het type organisatie is verplicht",
        blackboxFdm: "De FDM ID is verplicht",
        establishmentNumber: "Het vestigingsnummer is verplicht"
    }
};

const importPageStrings = {
    steps: {
        file: {
            label: "Bestand",
            title: "Kies het bestand om te importeren",
            description: "Een Excel-werkmap geëxporteerd uit Posbel of ingevuld op basis van het sjabloon, of een CSV-bestand.",
        },
        columns: {
            label: "Kolommen",
            title: "Kolommen koppelen",
            description: "Koppel elke kolom van uw bestand aan een Posbel-veld. Genegeerde kolommen worden niet geïmporteerd.",
        },
        check: {
            label: "Controle",
            title: "Controle van het bestand",
            description: "Elke regel is gecontroleerd. Regels met fouten worden weggelaten, ongeldige waarden genegeerd.",
        },
        references: {
            label: "Verwijzingen",
            title: "Onbekende verwijzingen",
            description: "Koppel de namen die nergens naar verwijzen.",
        },
        groups: {
            label: "Groepen",
            title: "Groepen",
            description: "Controleer de groepen die aangemaakt en hergebruikt worden.",
        },
        optionLists: {
            label: "Optielijsten",
            title: "Optielijsten",
            description: "Controleer de lijsten en hun keuzes.",
        },
        summary: {
            label: "Overzicht",
            title: "Overzicht",
            description: "Kies de producten om te importeren.",
        },
    },
    dropTitle: "Sleep uw bestand hierheen",
    dropSubtitle: "of klik om het te kiezen",
    readingFile: "{file} wordt gelezen...",
    templateHint: "Nog geen bestand? Begin met het sjabloon: het bevat alle kolommen, hulp onder elke kop en voorbeelden.",
    changeFile: "Ander bestand",
    readyTitle: "Het bestand kan geïmporteerd worden",
    blockedTitle: "Het bestand kan niet zo geïmporteerd worden",
    blockedDescription: "Verbeter de algemene fouten hieronder in uw bestand en laad het daarna opnieuw.",
    countProducts: "{count} product | {count} producten",
    countGroups: "{count} groep | {count} groepen",
    countOptionLists: "{count} optielijst | {count} optielijsten",
    sheetOf: "van {count} regel | van {count} regels",
    sheetExcluded: "{count} weggelaten | {count} weggelaten",
    sheetWarned: "{count} waarschuwing | {count} waarschuwingen",
    sheetAllValid: "Alles geldig",
    issuesTitle: "Gevonden problemen",
    filterAll: "Alle",
    filterErrors: "Fouten",
    filterWarnings: "Waarschuwingen",
    filterFixed: "Gecorrigeerd",
    issueRow: "regel {row}",
    express: {
        button: "Snelle import",
        title: "Snelle import",
        intro: "De standaardkeuze van elke stap wordt toegepast en de import wordt meteen verzonden.",
        notice: "Goed om te weten",
        lines: {
            products: "Product te importeren | Producten te importeren",
            groupsCreated: "Groep aan te maken | Groepen aan te maken",
            groupsReused: "Bestaande groep hergebruikt | Bestaande groepen hergebruikt",
            optionLists: "Optielijst | Optielijsten",
            excluded: "regel uitgesloten | regels uitgesloten",
            existing: "product al in Posbel overgeslagen | producten al in Posbel overgeslagen",
            matched: "naam automatisch gekoppeld | namen automatisch gekoppeld",
            renamed: "productnaam gecorrigeerd | productnamen gecorrigeerd",
        },
        blockers: {
            columns: "Koppel eerst de verplichte kolommen: naam, groep en prijs.",
            blocked: "Het bestand bevat een blokkerende fout, corrigeer die bij de stap Controle.",
            groupVat: "Sommige nieuwe groepen hebben geen btw, vul die in bij de stap Groepen.",
            noProducts: "Geen product om te importeren.",
        },
    },
    fix: {
        clear: "Leegmaken",
        skip: "Regel overslaan",
        newValue: "Nieuwe waarde",
        apply: "Toepassen",
        edited: "Waarde vervangen door “{value}”.",
        cleared: "Cel leeggemaakt.",
        skipped: "Regel overgeslagen, deze wordt niet geïmporteerd.",
        skipRows: "Regels overslaan",
        editTitle: "Waarde wijzigen",
        editManyTitle: "{count} cel wijzigen | {count} cellen wijzigen",
        currentValue: "huidige waarde “{value}”",
        columns: "Kolommen: {columns}",
        mixedColumns: "De cellen komen uit meerdere kolommen: dezelfde waarde wordt overal toegepast.",
        applySuggestion: "Voorstel toepassen",
        applySuggestions: "Voorstellen toepassen",
    },
    columns: {
        sheet: "Blad",
        required: "Verplicht:",
        ignore: "Negeren",
        untitled: "Kolom {number}",
        fields: {
            name: "Naam",
            group: "Groep",
            priceVatInclIn: "Prijs ter plaatse",
            priceVatInclOut: "Prijs afhaal",
            vatIn: "Btw ter plaatse",
            vatOut: "Btw afhaal",
            barcodes: "Barcodes",
            descriptionFr: "Beschrijving (FR)",
            descriptionNl: "Beschrijving (NL)",
            descriptionEn: "Beschrijving (EN)",
            color: "Kleur",
            imageUrl: "Afbeelding",
            externalReference: "Referentie",
            purchasePriceVatExcl: "Aankoopprijs excl. btw",
            orderIndex: "Volgorde",
            userHidden: "Verborgen op kassa",
            webHidden: "Verborgen op web",
            kioskHidden: "Verborgen op kiosk",
            dynamicPrice: "Dynamische prijs",
            weightPrice: "Prijs per gewicht",
        },
    },
    optionLists: {
        offeredOn: "aangeboden bij {count} product | aangeboden bij {count} producten",
        choiceCount: "{count} keuze | {count} keuzes",
        without: "Zonder {name}",
        maxTimes: "max. {count} keer",
        multiple: "Meerdere keren",
        free: "Gratis",
        pricePerChannel: "Prijs per kanaal",
        noChoice: "Geen keuze in deze lijst.",
    },
    summary: {
        selectedProducts: "{count} product van {total} te importeren | {count} producten van {total} te importeren",
        optionLists: "{count} optielijst | {count} optielijsten",
        existing: "{count} product bestaat al met deze naam in deze groep: het is uitgevinkt om een dubbel te vermijden. | {count} producten bestaan al met deze naam in hun groep: ze zijn uitgevinkt om dubbels te vermijden.",
        existingTag: "Al in Posbel",
        submit: "{count} product importeren | {count} producten importeren",
        success: "Import voltooid",
    },
    groups: {
        setVat: "Btw instellen",
        toCreate: "{count} groep aan te maken | {count} groepen aan te maken",
        toReuse: "{count} bestaande groep hergebruikt | {count} bestaande groepen hergebruikt",
        missingVat: "Vul de btw ter plaatse en afhaal van elke nieuwe groep in om verder te gaan.",
        new: "Nieuw",
        existing: "Al in Posbel",
        unchanged: "Bestaande groep, die niet gewijzigd wordt",
        productCount: "{count} product | {count} producten",
    },
    references: {
        autoCorrected: "{count} naam herkend ondanks een verschil in hoofdletters, accenten of spaties. | {count} namen herkend ondanks een verschil in hoofdletters, accenten of spaties.",
        kinds: {
            group: "Groepen",
            optionList: "Optielijsten",
            product: "Producten van de keuzes",
        },
        create: {
            group: "Nieuwe groep \"{value}\" aanmaken",
            optionList: "Nieuwe lijst \"{value}\" aanmaken",
        },
        replaceWith: "Vervangen door \"{value}\"",
        ignore: "Deze keuze negeren",
        fromFile: "In het bestand",
        fromPosbel: "Al in Posbel",
        ambiguous: "Meerdere producten hebben deze naam",
        rows: "regel {rows} | regels {rows}",
        allMatch: "Alle namen uit het bestand zijn gevonden",
    },
    issues: {
        unsupportedFormat: "Niet-ondersteund formaat. Gebruik een .xlsx- of .csv-bestand.",
        readError: "Het bestand kon niet gelezen worden. Controleer of het niet beschadigd of met een wachtwoord beveiligd is.",
        missingSheet: "Het tabblad {sheet} staat niet in het bestand.",
        noProducts: "Geen geldig product om te importeren.",
        unknownSheet: "Onbekend tabblad {sheet}, het wordt genegeerd.",
        optionListsDisabled: "Optielijsten zijn niet geactiveerd, het tabblad {sheet} wordt genegeerd.",
        unknownColumns: "Onbekende kolommen, genegeerd: {columns}.",
        missingColumn: "Verplichte kolom {column} niet gevonden. Het hele tabblad wordt genegeerd.",
        required: "Verplichte waarde ontbreekt. Regel weggelaten.",
        invalidNumber: "\"{value}\" is geen getal. Regel weggelaten.",
        invalidInteger: "\"{value}\" is geen geheel getal. Regel weggelaten.",
        negative: "\"{value}\" mag niet negatief zijn. Regel weggelaten.",
        invalidVat: "\"{value}\" is geen geldig btw-tarief ({rates}). Regel weggelaten.",
        invalidBoolean: "\"{value}\" is geen ja of nee. Waarde genegeerd.",
        invalidColor: "\"{value}\" is geen hexadecimale kleur. Waarde genegeerd.",
        invalidBarcode: "\"{value}\" is geen geldige barcode, die mag alleen cijfers bevatten. Waarde genegeerd.",
        barcodeTooLong: "Barcode “{value}” is te lang om opgeslagen te worden. Waarde genegeerd.",
        duplicate: "\"{value}\" komt al voor op regel {row}. Regel weggelaten.",
        invalidName: "“{value}” bevat niet-toegestane tekens. Voorstel: “{suggestion}”. Regel uitgesloten.",
        invalidNameNoSuggestion: "“{value}” bevat geen enkel toegestaan teken (letters, cijfers, spaties en - . , ' \" ( ) & % ° / +). Regel uitgesloten.",
        tooLong: "“{value}” telt {length} tekens, het maximum is {max}. Regel uitgesloten.",
        duplicateBarcode: "Barcode {value} wordt al gebruikt op regel {row}. Regel uitgesloten.",
    },
};

const catalogWorkbookStrings = {
    required: "Verplicht",
    optional: "Optioneel",
    validation: {
        title: "Ongeldige waarde",
        reference: "Kies een waarde uit de lijst, die uit het tabblad {sheet} komt. Voor een nieuwe waarde voegt u die eerst toe in het tabblad {sheet}.",
        boolean: "Kies {yes} of {no}.",
        vat: "Kies een btw-tarief: {rates}.",
    },
    help: {
        products: {
            name: "Naam van het product.",
            group: "Productgroep, met het volledige pad voor een subgroep: {example}. Kies een groep uit het tabblad Groups of typ een nieuwe: die wordt tijdens de import aangemaakt.",
            priceVatInclIn: "Prijs incl. btw ter plaatse.",
            priceVatInclOut: "Prijs incl. btw afhaal. Leeg = zelfde prijs als ter plaatse.",
            vatIn: "Btw-tarief ter plaatse in procent: 0, 6, 12 of 21. Leeg = btw van de groep.",
            vatOut: "Btw-tarief afhaal in procent. Leeg = zelfde tarief als ter plaatse.",
            barcodes: "Barcodes, meerdere gescheiden door een komma.",
            descriptionFr: "Beschrijving in het Frans.",
            descriptionNl: "Beschrijving in het Nederlands.",
            descriptionEn: "Beschrijving in het Engels.",
            color: "Kleur van de knop in hexadecimale notatie: {example}.",
            imageUrl: "https-link naar de afbeelding van het product.",
            externalReference: "Uw eigen referentie (artikelcode, SKU...).",
            purchasePriceVatExcl: "Aankoopprijs excl. btw.",
            orderIndex: "Weergavepositie in de groep, geheel getal.",
            userHidden: "Product verbergen op de kassa. Leeg = nee.",
            webHidden: "Product verbergen bij online bestellen. Leeg = nee.",
            kioskHidden: "Product verbergen op de kiosk. Leeg = nee.",
            dynamicPrice: "Dynamische prijs: de prijs wordt op de kassa ingegeven wanneer het product gekozen wordt, de prijs op deze rij wordt genegeerd. Leeg = nee.",
            weightPrice: "Prijs per gewicht: de prijs op deze rij is een kiloprijs en het gewicht wordt gevraagd wanneer het product gekozen wordt. Leeg = nee.",
            optionLists: "Optielijsten die aangeboden worden bij het bestellen van dit product, op naam (kolom name van het tabblad OptionLists), meerdere gescheiden door een komma, in weergavevolgorde.",
            freeOptionGroups: "Oud optiesysteem: groepen waarvan de producten gratis aangeboden worden, meerdere gescheiden door een komma.",
            paidOptionGroups: "Oud optiesysteem: groepen waarvan de producten betalend aangeboden worden, meerdere gescheiden door een komma.",
            productId: "Posbel-id van het product. Ingevuld bij export, genegeerd bij import.",
            stock: "Huidige voorraad. Ingevuld bij export, genegeerd bij import.",
        },
        groups: {
            path: "Volledig pad van de groep: {example}. Een bovenliggende groep heeft een eigen regel nodig.",
            vatIn: "Standaard btw ter plaatse van de producten van de groep, in procent.",
            vatOut: "Standaard btw afhaal van de producten van de groep, in procent.",
            color: "Kleur van de groep in hexadecimale notatie: {example}.",
            orderIndex: "Weergavepositie van de groep, geheel getal.",
            userHidden: "Groep verbergen op de kassa. Leeg = nee.",
            webHidden: "Groep verbergen bij online bestellen. Leeg = nee.",
            kioskHidden: "Groep verbergen op de kiosk. Leeg = nee.",
            imageUrl: "https-link naar de afbeelding van de groep.",
            externalReference: "Uw eigen referentie.",
            maxChoiceFree: "Oud optiesysteem: maximum aantal gratis keuzes in deze groep.",
            maxChoicePaid: "Oud optiesysteem: maximum aantal betalende keuzes in deze groep.",
            forceChoiceAmountFree: "Oud optiesysteem: verplicht aantal gratis keuzes.",
            forceChoiceAmountPaid: "Oud optiesysteem: verplicht aantal betalende keuzes.",
        },
        optionLists: {
            name: "Naam van de lijst. Deze naam schrijft u in de kolom optionLists van de producten en in de kolom list van de keuzes.",
            nameFr: "Naam getoond in het Frans. Leeg = de kolom name.",
            nameNl: "Naam getoond in het Nederlands. Leeg = de kolom name.",
            nameEn: "Naam getoond in het Engels. Leeg = de kolom name.",
            descriptionFr: "Beschrijving in het Frans.",
            descriptionNl: "Beschrijving in het Nederlands.",
            descriptionEn: "Beschrijving in het Engels.",
            minChoice: "Minimum aantal keuzes. Leeg = geen minimum.",
            maxChoice: "Maximum aantal keuzes. Leeg = geen maximum.",
            forceChoice: "Exact verplicht aantal keuzes. Leeg = niet verplicht.",
        },
        optionListItems: {
            list: "Naam van de lijst (kolom name van het tabblad OptionLists). De volgorde van de regels is de volgorde van de keuzes in de lijst.",
            product: "Naam van het product dat als keuze aangeboden wordt (tabblad Products).",
            productGroup: "Groep van het product. Alleen nodig als twee producten dezelfde naam hebben.",
            free: "Gratis keuze. Leeg = nee.",
            without: "Keuze \"Zonder ...\": de klant laat dit product weg. Leeg = nee.",
            allowMultipleChoice: "De klant kan deze keuze meerdere keren nemen. Leeg = nee.",
            maxChoice: "Maximum aantal keer voor deze keuze. Leeg = onbeperkt.",
            includeOptionLists: "Wanneer deze keuze genomen wordt, ook de optielijsten van het product aanbieden. Leeg = nee.",
            priceIn: "Speciale prijs ter plaatse voor alle kanalen. Leeg = prijs van het product.",
            priceOut: "Speciale prijs afhaal voor alle kanalen. Leeg = prijs van het product.",
            priceAppIn: "Speciale prijs ter plaatse op de kassa. Vervangt priceIn voor dit kanaal.",
            priceAppOut: "Speciale prijs afhaal op de kassa. Vervangt priceOut voor dit kanaal.",
            priceWebIn: "Speciale prijs ter plaatse bij online bestellen. Vervangt priceIn voor dit kanaal.",
            priceWebOut: "Speciale prijs afhaal bij online bestellen. Vervangt priceOut voor dit kanaal.",
            priceKioskIn: "Speciale prijs ter plaatse op de kiosk. Vervangt priceIn voor dit kanaal.",
            priceKioskOut: "Speciale prijs afhaal op de kiosk. Vervangt priceOut voor dit kanaal.",
        },
    },
    examples: {
        dishes: "Gerechten",
        pizzas: "Pizza's",
        extras: "Extra's",
        drinks: "Dranken",
        pizzaName: "Margherita",
        pizzaDescription: "Tomaat, mozzarella, basilicum",
        toppingName: "Extra mozzarella",
        drinkName: "Plat water 50 cl",
        listName: "Pizza-extra's",
        listDescription: "Kies tot 3 extra's",
    },
};

const quickMenuStrings = {
    argumentTextPlaceholder: "Je zoekterm...",
    argumentIdPlaceholder: "Id...",
    askProduct: "Begin met een productnaam of id te typen",
    askGroup: "Begin met een groepsnaam of id te typen",
    askClient: "Begin met een klantnaam of id te typen",
    askStock: "Begin met een productnaam of id te typen",
    askOrg: "Begin met een organisatienaam of id te typen",
    askAccount: "Voer een rekening-id in",
    askShift: "Voer een dienst-id in",
    askShiftStat: "Voer een dienst-id in",
    commandProduct: "Naar een product",
    commandGroup: "Catalogus — Naar een groep",
    commandClient: "Naar een klant",
    commandStock: "Voorraad van een product",
    commandOrg: "Organisatie wisselen",
    commandAccount: "Een rekening openen",
    commandShift: "Een dienst openen",
    commandShiftStat: "Dienststatistiek",
    kindCommand: "Commando",
    argumentPlaceholder: "Naam of id...",
    hintComplete: "aanvullen",
    switchOrg: "Wisselen naar",
    jump: "Direct openen",
    kindJump: "Snelkoppeling",
    openAccount: "Rekening openen",
    openShift: "Dienst openen",
    openShiftStat: "Dienststatistiek",
    openProduct: "Product openen",
    openGroup: "Groep openen",
    openClient: "Klant openen",
    openStock: "Voorraad product",
    clearRecent: "Wissen",
    settingsFields: "Instellingen",
    hintTabSettings: "Tab om te bewerken",
    hintSave: "opslaan",
    openInSettings: "Openen in instellingen",
    results: "Resultaten",
    suggestions: "Suggesties",
    placeholder: "Zoek een pagina of een actie...",
    goTo: "Ga naar",
    actions: "Snelle acties",
    recent: "Recent",
    kindPage: "Pagina",
    kindAction: "Actie",
    hintMove: "navigeren",
    hintOpen: "openen",
    hintToggle: "snelmenu"
}

export default {
    quickMenu: quickMenuStrings,
    generic: genericStrings,
    navBar: navBarStrings,
    toast: toastStrings,
    playlist: playlistStrings,
    deviceStrings: deviceStrings,
    dashboard: dashboardStrings,
    productGroupsDashboard: productGroupsDashboardStrings,
    loginPage: loginPageStrings,
    userPage: userPageStrings,
    superUserPage: superUserPageStrings,
    productGroupPage: productGroupPageStrings,
    productPage: productPageStrings,
    productOptionsPage: productOptionsPageStrings,
    catalogPage: catalogPageStrings,
    catalogWorkbook: catalogWorkbookStrings,
    importPage: importPageStrings,
    stockPage: stockPageStrings,
    tablePage: tableStrings,
    pickupPageStrings: pickupPageStrings,
    paymentsPage: paymentsStrings,
    orderedProductsPage: orderedProductsString,
    accountHistoryPage: accountHistory,
    openAccountsPage: openAccounts,
    shiftDetailPage: shiftDetail,
    shiftStatPage: shiftStat,
    clientStrings: clientStrings,
    shiftPage: shift,
    integrationStrings: integrationStrings,
    printerStrings: printerStrings,
    aiDebugger: aiDebuggerStrings,
    settingsPage: settingsPageStrings,
    deliveryAreaPage: deliveryAreaPageStrings,
    invoicePage: invoicePageStrings,
    kitchenPageStrings: kitchenPageStrings,
    promoPageStrings: promoPageStrings,
    voucherPageStrings: voucherPageStrings,
    imagePageStrings: imagePageStrings,
    iconsPageStrings: iconsPageStrings,
    websitePageStrings: websitePageStrings,
    topBar: topBarStrings,
    preferencesPage: preferencesPageStrings,
    createOrgPage: createOrgPageStrings
};
